// -------------------- Config type ------------------------- //
export const typeOptions = [
  {
    key: 'card',
    value: 'card',
    text: 'Card',
  },
  {
    key: 'chart',
    value: 'chart',
    text: 'Chart',
  },
  {
    key: 'dataGrid',
    value: 'dataGrid',
    text: 'Data Grid',
  },
  {
    key: 'form',
    value: 'form',
    text: 'Form',
  },
  {
    key: 'pivotPlaceholder',
    value: 'pivotPlaceholder',
    text: 'Pivot Placeholder',
  },
  // {
  //   key: "workflow",
  //   value: "workflow",
  //   text: "Workflow",
  // },
  // {
  //   key: "task",
  //   value: "task",
  //   text: "Task",
  // },
  {
    key: 'newProductionPlanning',
    value: 'newProductionPlanning',
    text: 'New Production Planning',
  },
  {
    key: 'productionAndPlanning',
    value: 'productionAndPlanning',
    text: 'Production & Planning',
  },
  {
    key: 'tableWithForm',
    value: 'tableWithForm',
    text: 'DataGrid With Form',
  },
];

// -------------------- card categories ------------------------- //
export const cardCategoriesConfigDetails = [
  {
    key: 'count',
    value: 'count',
    text: 'Count',
  },
  {
    key: 'progress',
    value: 'progress',
    text: 'Progress',
  },
  {
    key: 'status',
    value: 'status',
    text: 'status',
  },
];

// ------------------------- Name Config Details ------------------------------- //
export const tableNameOptions = [
  {
    key: 'master table',
    value: 'master table',
    text: 'Master Table',
  },
  {
    key: 'item table',
    value: 'item table',
    text: 'Item Table',
  },
  {
    key: 'view workflow table',
    value: 'view workflow table',
    text: 'View Workflow Table',
  },
  {
    key: 'history table',
    value: 'history table',
    text: 'History Table',
  },
  {
    key: 'workflow table',
    value: 'workflow table',
    text: 'Workflow Table',
  },
  {
    key: 'item group table',
    value: 'item group table',
    text: 'Item Group Table',
  },
];

// -------------------- chart options ------------------------ //
export const chartOptions = [
  {
    key: 'doughnut',
    value: 'doughnut',
    text: 'Doughnut',
    image: '/assets/doughnut.png',
  },
  {
    key: 'verticalBar',
    value: 'verticalBar',
    text: 'Vertical Bar',
    image: '/assets/verticalBar.png',
  },
  {
    key: 'horizontalBar',
    value: 'horizontalBar',
    text: 'Horizontal Bar',
    image: '/assets/horizontalBar.png',
  },
];

export const doughnutOptions = [
  // {
  //   key: 'task',
  //   value: 'task',
  //   text: 'Task',
  // },
  {
    key: 'elementType',
    value: 'elementType',
    text: 'Element Type',
  },
];

export const verticalBarOptions = [
  // {
  //   key: 'task',
  //   value: 'task',
  //   text: 'Task',
  // },
  {
    key: 'assetTracking',
    value: 'assetTracking',
    text: 'Asset Tracking',
  },
  {
    key: 'orderTracking',
    value: 'orderTracking',
    text: 'Order Tracking',
  },
  // {
  //   key: 'workflowStatus',
  //   value: 'workflowStatus',
  //   text: 'Workflow Status',
  // },
];

export const horizontalBarOptions = [
  {
    key: 'task',
    value: 'task',
    text: 'Task',
  },
  {
    key: 'assetTracking',
    value: 'assetTracking',
    text: 'Asset Tracking',
  },
  {
    key: 'orderTracking',
    value: 'orderTracking',
    text: 'Order Tracking',
  },
];

// -------------------- count config ------------------------- //
export const countConfigDetails = [
  {
    key: 'total_item',
    value: 'total_item',
    text: 'Total Item',
  },
  {
    key: 'total_order',
    value: 'total_order',
    text: 'Total Order',
  },
  {
    key: 'total_task',
    value: 'total_task',
    text: 'Total Task',
  },
  {
    key: 'completed_task',
    value: 'completed_task',
    text: 'Completed Task',
  },
  {
    key: 'completed_order',
    value: 'completed_order',
    text: 'Completed Order',
  },
  {
    key: 'total_workflow',
    value: 'total_workflow',
    text: 'Total Workflow',
  },
  // {
  //   key: "total_outward",
  //   value: "total_outward",
  //   text: "Total outward",
  // }
];

export const cardConfigDetails = [
  {
    key: 'style 1',
    value: 'style 1',
    text: 'Style 1',
  },
  {
    key: 'style 2',
    value: 'style 2',
    text: 'Style 2',
  },
];

export const staticTableDetails = [
  // {
  //   key: 'inventory',
  //   value: 'inventory',
  //   text: 'Inventory',
  // },
  // {
  //   key: 'delivery',
  //   value: 'delivery',
  //   text: 'Delivery',
  // },
  // {
  //   key: 'outward',
  //   value: 'outward',
  //   text: 'Outward',
  // },
  // {
  //   key: 'inward',
  //   value: 'inward',
  //   text: 'Inward',
  // },
];

// -------------------- semantic ui react icons ------------------------- //
export const iconDetails = [
  {
    key: 'american sign language interpreting',
    value: 'american sign language interpreting',
    text: 'American sign language interpreting',
    icon: 'american sign language interpreting',
  },
  {
    key: 'assistive listening systems',
    value: 'assistive listening systems',
    text: 'Assistive listening systems',
    icon: 'assistive listening systems',
  },
  {
    key: 'audio description',
    value: 'audio description',
    text: 'Audio description',
    icon: 'audio description',
  },
  {
    key: 'blind',
    value: 'blind',
    text: 'Blind',
    icon: 'blind',
  },
  {
    key: 'braille',
    value: 'braille',
    text: 'Braille',
    icon: 'braille',
  },
  {
    key: 'closed captioning',
    value: 'closed captioning',
    text: 'Closed captioning',
    icon: 'closed captioning',
  },
  {
    key: 'closed captioning outline',
    value: 'closed captioning outline',
    text: 'Closed captioning outline',
    icon: 'closed captioning outline',
  },
  {
    key: 'deaf',
    value: 'deaf',
    text: 'Deaf',
    icon: 'deaf',
  },
  {
    key: 'low vision',
    value: 'low vision',
    text: 'Low vision',
    icon: 'low vision',
  },
  {
    key: 'phone volume',
    value: 'phone volume',
    text: 'Phone volume',
    icon: 'phone volume',
  },
  {
    key: 'question circle',
    value: 'question circle',
    text: 'Question circle',
    icon: 'question circle',
  },
  {
    key: 'question circle outline',
    value: 'question circle outline',
    text: 'Question circle outline',
    icon: 'question circle outline',
  },
  {
    key: 'sign language',
    value: 'sign language',
    text: 'Sign language',
    icon: 'sign language',
  },
  {
    key: 'tty',
    value: 'tty',
    text: 'Tty',
    icon: 'tty',
  },
  {
    key: 'universal access',
    value: 'universal access',
    text: 'Universal access',
    icon: 'universal access',
  },
  {
    key: 'wheelchair',
    value: 'wheelchair',
    text: 'Wheelchair',
    icon: 'wheelchair',
  },
  {
    key: 'angle double down',
    value: 'angle double down',
    text: 'Angle double down',
    icon: 'angle double down',
  },
  {
    key: 'angle double left',
    value: 'angle double left',
    text: 'Angle double left',
    icon: 'angle double left',
  },
  {
    key: 'angle double right',
    value: 'angle double right',
    text: 'Angle double right',
    icon: 'angle double right',
  },
  {
    key: 'angle double up',
    value: 'angle double up',
    text: 'Angle double up',
    icon: 'angle double up',
  },
  {
    key: 'angle down',
    value: 'angle down',
    text: 'Angle down',
    icon: 'angle down',
  },
  {
    key: 'angle left',
    value: 'angle left',
    text: 'Angle left',
    icon: 'angle left',
  },
  {
    key: 'angle right',
    value: 'angle right',
    text: 'Angle right',
    icon: 'angle right',
  },
  {
    key: 'angle up',
    value: 'angle up',
    text: 'Angle up',
    icon: 'angle up',
  },
  {
    key: 'arrow alternate circle down',
    value: 'arrow alternate circle down',
    text: 'Arrow alternate circle down',
    icon: 'arrow alternate circle down',
  },
  {
    key: 'arrow alternate circle down outline',
    value: 'arrow alternate circle down outline',
    text: 'Arrow alternate circle down outline',
    icon: 'arrow alternate circle down outline',
  },
  {
    key: 'arrow alternate circle left',
    value: 'arrow alternate circle left',
    text: 'Arrow alternate circle left',
    icon: 'arrow alternate circle left',
  },
  {
    key: 'arrow alternate circle left outline',
    value: 'arrow alternate circle left outline',
    text: 'Arrow alternate circle left outline',
    icon: 'arrow alternate circle left outline',
  },
  {
    key: 'arrow alternate circle right',
    value: 'arrow alternate circle right',
    text: 'Arrow alternate circle right',
    icon: 'arrow alternate circle right',
  },
  {
    key: 'arrow alternate circle right outline',
    value: 'arrow alternate circle right outline',
    text: 'Arrow alternate circle right outline',
    icon: 'arrow alternate circle right outline',
  },
  {
    key: 'arrow alternate circle up',
    value: 'arrow alternate circle up',
    text: 'Arrow alternate circle up',
    icon: 'arrow alternate circle up',
  },
  {
    key: 'arrow alternate circle up outline',
    value: 'arrow alternate circle up outline',
    text: 'Arrow alternate circle up outline',
    icon: 'arrow alternate circle up outline',
  },
  {
    key: 'arrow circle down',
    value: 'arrow circle down',
    text: 'Arrow circle down',
    icon: 'arrow circle down',
  },
  {
    key: 'arrow circle left',
    value: 'arrow circle left',
    text: 'Arrow circle left',
    icon: 'arrow circle left',
  },
  {
    key: 'arrow circle right',
    value: 'arrow circle right',
    text: 'Arrow circle right',
    icon: 'arrow circle right',
  },
  {
    key: 'arrow circle up',
    value: 'arrow circle up',
    text: 'Arrow circle up',
    icon: 'arrow circle up',
  },
  {
    key: 'arrow down',
    value: 'arrow down',
    text: 'Arrow down',
    icon: 'arrow down',
  },
  {
    key: 'arrow left',
    value: 'arrow left',
    text: 'Arrow left',
    icon: 'arrow left',
  },
  {
    key: 'arrow right',
    value: 'arrow right',
    text: 'Arrow right',
    icon: 'arrow right',
  },
  {
    key: 'arrow up',
    value: 'arrow up',
    text: 'Arrow up',
    icon: 'arrow up',
  },
  {
    key: 'arrows alternate',
    value: 'arrows alternate',
    text: 'Arrows alternate',
    icon: 'arrows alternate',
  },
  {
    key: 'arrows alternate horizontal',
    value: 'arrows alternate horizontal',
    text: 'Arrows alternate horizontal',
    icon: 'arrows alternate horizontal',
  },
  {
    key: 'arrows alternate vertical',
    value: 'arrows alternate vertical',
    text: 'Arrows alternate vertical',
    icon: 'arrows alternate vertical',
  },
  {
    key: 'caret down',
    value: 'caret down',
    text: 'Caret down',
    icon: 'caret down',
  },
  {
    key: 'caret left',
    value: 'caret left',
    text: 'Caret left',
    icon: 'caret left',
  },
  {
    key: 'caret right',
    value: 'caret right',
    text: 'Caret right',
    icon: 'caret right',
  },
  {
    key: 'caret square down',
    value: 'caret square down',
    text: 'Caret square down',
    icon: 'caret square down',
  },
  {
    key: 'caret square down outline',
    value: 'caret square down outline',
    text: 'Caret square down outline',
    icon: 'caret square down outline',
  },
  {
    key: 'caret square left',
    value: 'caret square left',
    text: 'Caret square left',
    icon: 'caret square left',
  },
  {
    key: 'caret square left outline',
    value: 'caret square left outline',
    text: 'Caret square left outline',
    icon: 'caret square left outline',
  },
  {
    key: 'caret square right',
    value: 'caret square right',
    text: 'Caret square right',
    icon: 'caret square right',
  },
  {
    key: 'caret square right outline',
    value: 'caret square right outline',
    text: 'Caret square right outline',
    icon: 'caret square right outline',
  },
  {
    key: 'caret square up',
    value: 'caret square up',
    text: 'Caret square up',
    icon: 'caret square up',
  },
  {
    key: 'caret square up outline',
    value: 'caret square up outline',
    text: 'Caret square up outline',
    icon: 'caret square up outline',
  },
  {
    key: 'caret up',
    value: 'caret up',
    text: 'Caret up',
    icon: 'caret up',
  },
  {
    key: 'cart arrow down',
    value: 'cart arrow down',
    text: 'Cart arrow down',
    icon: 'cart arrow down',
  },
  {
    key: 'chart line',
    value: 'chart line',
    text: 'Chart line',
    icon: 'chart line',
  },
  {
    key: 'chevron circle down',
    value: 'chevron circle down',
    text: 'Chevron circle down',
    icon: 'chevron circle down',
  },
  {
    key: 'chevron circle left',
    value: 'chevron circle left',
    text: 'Chevron circle left',
    icon: 'chevron circle left',
  },
  {
    key: 'chevron circle right',
    value: 'chevron circle right',
    text: 'Chevron circle right',
    icon: 'chevron circle right',
  },
  {
    key: 'chevron circle up',
    value: 'chevron circle up',
    text: 'Chevron circle up',
    icon: 'chevron circle up',
  },
  {
    key: 'chevron down',
    value: 'chevron down',
    text: 'Chevron down',
    icon: 'chevron down',
  },
  {
    key: 'chevron left',
    value: 'chevron left',
    text: 'Chevron left',
    icon: 'chevron left',
  },
  {
    key: 'chevron right',
    value: 'chevron right',
    text: 'Chevron right',
    icon: 'chevron right',
  },
  {
    key: 'chevron up',
    value: 'chevron up',
    text: 'Chevron up',
    icon: 'chevron up',
  },
  {
    key: 'cloud download',
    value: 'cloud download',
    text: 'Cloud download',
    icon: 'cloud download',
  },
  {
    key: 'cloud upload',
    value: 'cloud upload',
    text: 'Cloud upload',
    icon: 'cloud upload',
  },
  {
    key: 'download',
    value: 'download',
    text: 'Download',
    icon: 'download',
  },
  {
    key: 'exchange',
    value: 'exchange',
    text: 'Exchange',
    icon: 'exchange',
  },
  {
    key: 'expand arrows alternate',
    value: 'expand arrows alternate',
    text: 'Expand arrows alternate',
    icon: 'expand arrows alternate',
  },
  {
    key: 'external alternate',
    value: 'external alternate',
    text: 'External alternate',
    icon: 'external alternate',
  },
  {
    key: 'external square alternate',
    value: 'external square alternate',
    text: 'External square alternate',
    icon: 'external square alternate',
  },
  {
    key: 'hand point down',
    value: 'hand point down',
    text: 'Hand point down',
    icon: 'hand point down',
  },
  {
    key: 'hand point down outline',
    value: 'hand point down outline',
    text: 'Hand point down outline',
    icon: 'hand point down outline',
  },
  {
    key: 'hand point left',
    value: 'hand point left',
    text: 'Hand point left',
    icon: 'hand point left',
  },
  {
    key: 'hand point left outline',
    value: 'hand point left outline',
    text: 'Hand point left outline',
    icon: 'hand point left outline',
  },
  {
    key: 'hand point right',
    value: 'hand point right',
    text: 'Hand point right',
    icon: 'hand point right',
  },
  {
    key: 'hand point right outline',
    value: 'hand point right outline',
    text: 'Hand point right outline',
    icon: 'hand point right outline',
  },
  {
    key: 'hand point up',
    value: 'hand point up',
    text: 'Hand point up',
    icon: 'hand point up',
  },
  {
    key: 'hand point up outline',
    value: 'hand point up outline',
    text: 'Hand point up outline',
    icon: 'hand point up outline',
  },
  {
    key: 'hand pointer',
    value: 'hand pointer',
    text: 'Hand pointer',
    icon: 'hand pointer',
  },
  {
    key: 'hand pointer outline',
    value: 'hand pointer outline',
    text: 'Hand pointer outline',
    icon: 'hand pointer outline',
  },
  {
    key: 'history',
    value: 'history',
    text: 'History',
    icon: 'history',
  },
  {
    key: 'level down alternate',
    value: 'level down alternate',
    text: 'Level down alternate',
    icon: 'level down alternate',
  },
  {
    key: 'level up alternate',
    value: 'level up alternate',
    text: 'Level up alternate',
    icon: 'level up alternate',
  },
  {
    key: 'location arrow',
    value: 'location arrow',
    text: 'Location arrow',
    icon: 'location arrow',
  },
  {
    key: 'long arrow alternate down',
    value: 'long arrow alternate down',
    text: 'Long arrow alternate down',
    icon: 'long arrow alternate down',
  },
  {
    key: 'long arrow alternate left',
    value: 'long arrow alternate left',
    text: 'Long arrow alternate left',
    icon: 'long arrow alternate left',
  },
  {
    key: 'long arrow alternate right',
    value: 'long arrow alternate right',
    text: 'Long arrow alternate right',
    icon: 'long arrow alternate right',
  },
  {
    key: 'long arrow alternate up',
    value: 'long arrow alternate up',
    text: 'Long arrow alternate up',
    icon: 'long arrow alternate up',
  },
  {
    key: 'mouse pointer',
    value: 'mouse pointer',
    text: 'Mouse pointer',
    icon: 'mouse pointer',
  },
  {
    key: 'play',
    value: 'play',
    text: 'Play',
    icon: 'play',
  },
  {
    key: 'random',
    value: 'random',
    text: 'Random',
    icon: 'random',
  },
  {
    key: 'recycle',
    value: 'recycle',
    text: 'Recycle',
    icon: 'recycle',
  },
  {
    key: 'redo',
    value: 'redo',
    text: 'Redo',
    icon: 'redo',
  },
  {
    key: 'redo alternate',
    value: 'redo alternate',
    text: 'Redo alternate',
    icon: 'redo alternate',
  },
  {
    key: 'reply',
    value: 'reply',
    text: 'Reply',
    icon: 'reply',
  },
  {
    key: 'reply all',
    value: 'reply all',
    text: 'Reply all',
    icon: 'reply all',
  },
  {
    key: 'retweet',
    value: 'retweet',
    text: 'Retweet',
    icon: 'retweet',
  },
  {
    key: 'share',
    value: 'share',
    text: 'Share',
    icon: 'share',
  },
  {
    key: 'share square',
    value: 'share square',
    text: 'Share square',
    icon: 'share square',
  },
  {
    key: 'share square outline',
    value: 'share square outline',
    text: 'Share square outline',
    icon: 'share square outline',
  },
  {
    key: 'sign-in',
    value: 'sign-in',
    text: 'Sign-in',
    icon: 'sign-in',
  },
  {
    key: 'sign-out',
    value: 'sign-out',
    text: 'Sign-out',
    icon: 'sign-out',
  },
  {
    key: 'sign-in alternate',
    value: 'sign-in alternate',
    text: 'Sign-in alternate',
    icon: 'sign-in alternate',
  },
  {
    key: 'sign-out alternate',
    value: 'sign-out alternate',
    text: 'Sign-out alternate',
    icon: 'sign-out alternate',
  },
  {
    key: 'sort',
    value: 'sort',
    text: 'Sort',
    icon: 'sort',
  },
  {
    key: 'sort alphabet down',
    value: 'sort alphabet down',
    text: 'Sort alphabet down',
    icon: 'sort alphabet down',
  },
  {
    key: 'sort alphabet up',
    value: 'sort alphabet up',
    text: 'Sort alphabet up',
    icon: 'sort alphabet up',
  },
  {
    key: 'sort amount down',
    value: 'sort amount down',
    text: 'Sort amount down',
    icon: 'sort amount down',
  },
  {
    key: 'sort amount up',
    value: 'sort amount up',
    text: 'Sort amount up',
    icon: 'sort amount up',
  },
  {
    key: 'sort down',
    value: 'sort down',
    text: 'Sort down',
    icon: 'sort down',
  },
  {
    key: 'sort numeric down',
    value: 'sort numeric down',
    text: 'Sort numeric down',
    icon: 'sort numeric down',
  },
  {
    key: 'sort numeric up',
    value: 'sort numeric up',
    text: 'Sort numeric up',
    icon: 'sort numeric up',
  },
  {
    key: 'sort up',
    value: 'sort up',
    text: 'Sort up',
    icon: 'sort up',
  },
  {
    key: 'sync',
    value: 'sync',
    text: 'Sync',
    icon: 'sync',
  },
  {
    key: 'sync alternate',
    value: 'sync alternate',
    text: 'Sync alternate',
    icon: 'sync alternate',
  },
  {
    key: 'text height',
    value: 'text height',
    text: 'Text height',
    icon: 'text height',
  },
  {
    key: 'text width',
    value: 'text width',
    text: 'Text width',
    icon: 'text width',
  },
  {
    key: 'undo',
    value: 'undo',
    text: 'Undo',
    icon: 'undo',
  },
  {
    key: 'undo alternate',
    value: 'undo alternate',
    text: 'Undo alternate',
    icon: 'undo alternate',
  },
  {
    key: 'upload',
    value: 'upload',
    text: 'Upload',
    icon: 'upload',
  },
  {
    key: 'zoom-in',
    value: 'zoom-in',
    text: 'Zoom-in',
    icon: 'zoom-in',
  },
  {
    key: 'zoom-out',
    value: 'zoom-out',
    text: 'Zoom-out',
    icon: 'zoom-out',
  },
  {
    key: 'backward',
    value: 'backward',
    text: 'Backward',
    icon: 'backward',
  },
  {
    key: 'circle',
    value: 'circle',
    text: 'Circle',
    icon: 'circle',
  },
  {
    key: 'circle outline',
    value: 'circle outline',
    text: 'Circle outline',
    icon: 'circle outline',
  },
  {
    key: 'compress',
    value: 'compress',
    text: 'Compress',
    icon: 'compress',
  },
  {
    key: 'eject',
    value: 'eject',
    text: 'Eject',
    icon: 'eject',
  },
  {
    key: 'expand',
    value: 'expand',
    text: 'Expand',
    icon: 'expand',
  },
  {
    key: 'fast backward',
    value: 'fast backward',
    text: 'Fast backward',
    icon: 'fast backward',
  },
  {
    key: 'fast forward',
    value: 'fast forward',
    text: 'Fast forward',
    icon: 'fast forward',
  },
  {
    key: 'file audio',
    value: 'file audio',
    text: 'File audio',
    icon: 'file audio',
  },
  {
    key: 'file audio outline',
    value: 'file audio outline',
    text: 'File audio outline',
    icon: 'file audio outline',
  },
  {
    key: 'file video',
    value: 'file video',
    text: 'File video',
    icon: 'file video',
  },
  {
    key: 'file video outline',
    value: 'file video outline',
    text: 'File video outline',
    icon: 'file video outline',
  },
  {
    key: 'film',
    value: 'film',
    text: 'Film',
    icon: 'film',
  },
  {
    key: 'forward',
    value: 'forward',
    text: 'Forward',
    icon: 'forward',
  },
  {
    key: 'headphones',
    value: 'headphones',
    text: 'Headphones',
    icon: 'headphones',
  },
  {
    key: 'microphone',
    value: 'microphone',
    text: 'Microphone',
    icon: 'microphone',
  },
  {
    key: 'microphone slash',
    value: 'microphone slash',
    text: 'Microphone slash',
    icon: 'microphone slash',
  },
  {
    key: 'music',
    value: 'music',
    text: 'Music',
    icon: 'music',
  },
  {
    key: 'pause',
    value: 'pause',
    text: 'Pause',
    icon: 'pause',
  },
  {
    key: 'pause circle',
    value: 'pause circle',
    text: 'Pause circle',
    icon: 'pause circle',
  },
  {
    key: 'pause circle outline',
    value: 'pause circle outline',
    text: 'Pause circle outline',
    icon: 'pause circle outline',
  },
  {
    key: 'play circle',
    value: 'play circle',
    text: 'Play circle',
    icon: 'play circle',
  },
  {
    key: 'play circle outline',
    value: 'play circle outline',
    text: 'Play circle outline',
    icon: 'play circle outline',
  },
  {
    key: 'podcast',
    value: 'podcast',
    text: 'Podcast',
    icon: 'podcast',
  },
  {
    key: 'rss',
    value: 'rss',
    text: 'Rss',
    icon: 'rss',
  },
  {
    key: 'rss square',
    value: 'rss square',
    text: 'Rss square',
    icon: 'rss square',
  },
  {
    key: 'step backward',
    value: 'step backward',
    text: 'Step backward',
    icon: 'step backward',
  },
  {
    key: 'step forward',
    value: 'step forward',
    text: 'Step forward',
    icon: 'step forward',
  },
  {
    key: 'stop',
    value: 'stop',
    text: 'Stop',
    icon: 'stop',
  },
  {
    key: 'stop circle',
    value: 'stop circle',
    text: 'Stop circle',
    icon: 'stop circle',
  },
  {
    key: 'stop circle outline',
    value: 'stop circle outline',
    text: 'Stop circle outline',
    icon: 'stop circle outline',
  },
  {
    key: 'video',
    value: 'video',
    text: 'Video',
    icon: 'video',
  },
  {
    key: 'volume down',
    value: 'volume down',
    text: 'Volume down',
    icon: 'volume down',
  },
  {
    key: 'volume off',
    value: 'volume off',
    text: 'Volume off',
    icon: 'volume off',
  },
  {
    key: 'volume up',
    value: 'volume up',
    text: 'Volume up',
    icon: 'volume up',
  },
  {
    key: 'address book',
    value: 'address book',
    text: 'Address book',
    icon: 'address book',
  },
  {
    key: 'address book outline',
    value: 'address book outline',
    text: 'Address book outline',
    icon: 'address book outline',
  },
  {
    key: 'address card',
    value: 'address card',
    text: 'Address card',
    icon: 'address card',
  },
  {
    key: 'address card outline',
    value: 'address card outline',
    text: 'Address card outline',
    icon: 'address card outline',
  },
  {
    key: 'archive',
    value: 'archive',
    text: 'Archive',
    icon: 'archive',
  },
  {
    key: 'balance scale',
    value: 'balance scale',
    text: 'Balance scale',
    icon: 'balance scale',
  },
  {
    key: 'birthday cake',
    value: 'birthday cake',
    text: 'Birthday cake',
    icon: 'birthday cake',
  },
  {
    key: 'book',
    value: 'book',
    text: 'Book',
    icon: 'book',
  },
  {
    key: 'briefcase',
    value: 'briefcase',
    text: 'Briefcase',
    icon: 'briefcase',
  },
  {
    key: 'building',
    value: 'building',
    text: 'Building',
    icon: 'building',
  },
  {
    key: 'building outline',
    value: 'building outline',
    text: 'Building outline',
    icon: 'building outline',
  },
  {
    key: 'bullhorn',
    value: 'bullhorn',
    text: 'Bullhorn',
    icon: 'bullhorn',
  },
  {
    key: 'bullseye',
    value: 'bullseye',
    text: 'Bullseye',
    icon: 'bullseye',
  },
  {
    key: 'calculator',
    value: 'calculator',
    text: 'Calculator',
    icon: 'calculator',
  },
  {
    key: 'calendar',
    value: 'calendar',
    text: 'Calendar',
    icon: 'calendar',
  },
  {
    key: 'calendar outline',
    value: 'calendar outline',
    text: 'Calendar outline',
    icon: 'calendar outline',
  },
  {
    key: 'calendar alternate',
    value: 'calendar alternate',
    text: 'Calendar alternate',
    icon: 'calendar alternate',
  },
  {
    key: 'calendar alternate outline',
    value: 'calendar alternate outline',
    text: 'Calendar alternate outline',
    icon: 'calendar alternate outline',
  },
  {
    key: 'certificate',
    value: 'certificate',
    text: 'Certificate',
    icon: 'certificate',
  },
  {
    key: 'chart area',
    value: 'chart area',
    text: 'Chart area',
    icon: 'chart area',
  },
  {
    key: 'chart bar',
    value: 'chart bar',
    text: 'Chart bar',
    icon: 'chart bar',
  },
  {
    key: 'chart bar outline',
    value: 'chart bar outline',
    text: 'Chart bar outline',
    icon: 'chart bar outline',
  },
  {
    key: 'chart pie',
    value: 'chart pie',
    text: 'Chart pie',
    icon: 'chart pie',
  },
  {
    key: 'clipboard',
    value: 'clipboard',
    text: 'Clipboard',
    icon: 'clipboard',
  },
  {
    key: 'clipboard outline',
    value: 'clipboard outline',
    text: 'Clipboard outline',
    icon: 'clipboard outline',
  },
  {
    key: 'coffee',
    value: 'coffee',
    text: 'Coffee',
    icon: 'coffee',
  },
  {
    key: 'columns',
    value: 'columns',
    text: 'Columns',
    icon: 'columns',
  },
  {
    key: 'compass',
    value: 'compass',
    text: 'Compass',
    icon: 'compass',
  },
  {
    key: 'compass outline',
    value: 'compass outline',
    text: 'Compass outline',
    icon: 'compass outline',
  },
  {
    key: 'copy',
    value: 'copy',
    text: 'Copy',
    icon: 'copy',
  },
  {
    key: 'copy outline',
    value: 'copy outline',
    text: 'Copy outline',
    icon: 'copy outline',
  },
  {
    key: 'copyright',
    value: 'copyright',
    text: 'Copyright',
    icon: 'copyright',
  },
  {
    key: 'copyright outline',
    value: 'copyright outline',
    text: 'Copyright outline',
    icon: 'copyright outline',
  },
  {
    key: 'cut',
    value: 'cut',
    text: 'Cut',
    icon: 'cut',
  },
  {
    key: 'edit',
    value: 'edit',
    text: 'Edit',
    icon: 'edit',
  },
  {
    key: 'edit outline',
    value: 'edit outline',
    text: 'Edit outline',
    icon: 'edit outline',
  },
  {
    key: 'envelope',
    value: 'envelope',
    text: 'Envelope',
    icon: 'envelope',
  },
  {
    key: 'envelope outline',
    value: 'envelope outline',
    text: 'Envelope outline',
    icon: 'envelope outline',
  },
  {
    key: 'envelope open',
    value: 'envelope open',
    text: 'Envelope open',
    icon: 'envelope open',
  },
  {
    key: 'envelope open outline',
    value: 'envelope open outline',
    text: 'Envelope open outline',
    icon: 'envelope open outline',
  },
  {
    key: 'envelope square',
    value: 'envelope square',
    text: 'Envelope square',
    icon: 'envelope square',
  },
  {
    key: 'eraser',
    value: 'eraser',
    text: 'Eraser',
    icon: 'eraser',
  },
  {
    key: 'fax',
    value: 'fax',
    text: 'Fax',
    icon: 'fax',
  },
  {
    key: 'file',
    value: 'file',
    text: 'File',
    icon: 'file',
  },
  {
    key: 'file outline',
    value: 'file outline',
    text: 'File outline',
    icon: 'file outline',
  },
  {
    key: 'file alternate',
    value: 'file alternate',
    text: 'File alternate',
    icon: 'file alternate',
  },
  {
    key: 'file alternate outline',
    value: 'file alternate outline',
    text: 'File alternate outline',
    icon: 'file alternate outline',
  },
  {
    key: 'folder',
    value: 'folder',
    text: 'Folder',
    icon: 'folder',
  },
  {
    key: 'folder outline',
    value: 'folder outline',
    text: 'Folder outline',
    icon: 'folder outline',
  },
  {
    key: 'folder open',
    value: 'folder open',
    text: 'Folder open',
    icon: 'folder open',
  },
  {
    key: 'folder open outline',
    value: 'folder open outline',
    text: 'Folder open outline',
    icon: 'folder open outline',
  },
  {
    key: 'globe',
    value: 'globe',
    text: 'Globe',
    icon: 'globe',
  },
  {
    key: 'industry',
    value: 'industry',
    text: 'Industry',
    icon: 'industry',
  },
  {
    key: 'paperclip',
    value: 'paperclip',
    text: 'Paperclip',
    icon: 'paperclip',
  },
  {
    key: 'paste',
    value: 'paste',
    text: 'Paste',
    icon: 'paste',
  },
  {
    key: 'pen square',
    value: 'pen square',
    text: 'Pen square',
    icon: 'pen square',
  },
  {
    key: 'pencil alternate',
    value: 'pencil alternate',
    text: 'Pencil alternate',
    icon: 'pencil alternate',
  },
  {
    key: 'percent',
    value: 'percent',
    text: 'Percent',
    icon: 'percent',
  },
  {
    key: 'phone',
    value: 'phone',
    text: 'Phone',
    icon: 'phone',
  },
  {
    key: 'phone square',
    value: 'phone square',
    text: 'Phone square',
    icon: 'phone square',
  },
  {
    key: 'registered',
    value: 'registered',
    text: 'Registered',
    icon: 'registered',
  },
  {
    key: 'registered outline',
    value: 'registered outline',
    text: 'Registered outline',
    icon: 'registered outline',
  },
  {
    key: 'save',
    value: 'save',
    text: 'Save',
    icon: 'save',
  },
  {
    key: 'save outline',
    value: 'save outline',
    text: 'Save outline',
    icon: 'save outline',
  },
  {
    key: 'sitemap',
    value: 'sitemap',
    text: 'Sitemap',
    icon: 'sitemap',
  },
  {
    key: 'sticky note',
    value: 'sticky note',
    text: 'Sticky note',
    icon: 'sticky note',
  },
  {
    key: 'sticky note outline',
    value: 'sticky note outline',
    text: 'Sticky note outline',
    icon: 'sticky note outline',
  },
  {
    key: 'suitcase',
    value: 'suitcase',
    text: 'Suitcase',
    icon: 'suitcase',
  },
  {
    key: 'table',
    value: 'table',
    text: 'Table',
    icon: 'table',
  },
  {
    key: 'tag',
    value: 'tag',
    text: 'Tag',
    icon: 'tag',
  },
  {
    key: 'tags',
    value: 'tags',
    text: 'Tags',
    icon: 'tags',
  },
  {
    key: 'tasks',
    value: 'tasks',
    text: 'Tasks',
    icon: 'tasks',
  },
  {
    key: 'thumbtack',
    value: 'thumbtack',
    text: 'Thumbtack',
    icon: 'thumbtack',
  },
  {
    key: 'trademark',
    value: 'trademark',
    text: 'Trademark',
    icon: 'trademark',
  },
  {
    key: 'chess',
    value: 'chess',
    text: 'Chess',
    icon: 'chess',
  },
  {
    key: 'chess bishop',
    value: 'chess bishop',
    text: 'Chess bishop',
    icon: 'chess bishop',
  },
  {
    key: 'chess board',
    value: 'chess board',
    text: 'Chess board',
    icon: 'chess board',
  },
  {
    key: 'chess king',
    value: 'chess king',
    text: 'Chess king',
    icon: 'chess king',
  },
  {
    key: 'chess knight',
    value: 'chess knight',
    text: 'Chess knight',
    icon: 'chess knight',
  },
  {
    key: 'chess pawn',
    value: 'chess pawn',
    text: 'Chess pawn',
    icon: 'chess pawn',
  },
  {
    key: 'chess queen',
    value: 'chess queen',
    text: 'Chess queen',
    icon: 'chess queen',
  },
  {
    key: 'chess rook',
    value: 'chess rook',
    text: 'Chess rook',
    icon: 'chess rook',
  },
  {
    key: 'square full',
    value: 'square full',
    text: 'Square full',
    icon: 'square full',
  },
  {
    key: 'barcode',
    value: 'barcode',
    text: 'Barcode',
    icon: 'barcode',
  },
  {
    key: 'bath',
    value: 'bath',
    text: 'Bath',
    icon: 'bath',
  },
  {
    key: 'bug',
    value: 'bug',
    text: 'Bug',
    icon: 'bug',
  },
  {
    key: 'code',
    value: 'code',
    text: 'Code',
    icon: 'code',
  },
  {
    key: 'code branch',
    value: 'code branch',
    text: 'Code branch',
    icon: 'code branch',
  },
  {
    key: 'file code',
    value: 'file code',
    text: 'File code',
    icon: 'file code',
  },
  {
    key: 'file code outline',
    value: 'file code outline',
    text: 'File code outline',
    icon: 'file code outline',
  },
  {
    key: 'filter',
    value: 'filter',
    text: 'Filter',
    icon: 'filter',
  },
  {
    key: 'fire extinguisher',
    value: 'fire extinguisher',
    text: 'Fire extinguisher',
    icon: 'fire extinguisher',
  },
  {
    key: 'keyboard',
    value: 'keyboard',
    text: 'Keyboard',
    icon: 'keyboard',
  },
  {
    key: 'keyboard outline',
    value: 'keyboard outline',
    text: 'Keyboard outline',
    icon: 'keyboard outline',
  },
  {
    key: 'microchip',
    value: 'microchip',
    text: 'Microchip',
    icon: 'microchip',
  },
  {
    key: 'qrcode',
    value: 'qrcode',
    text: 'Qrcode',
    icon: 'qrcode',
  },
  {
    key: 'shield alternate',
    value: 'shield alternate',
    text: 'Shield alternate',
    icon: 'shield alternate',
  },
  {
    key: 'terminal',
    value: 'terminal',
    text: 'Terminal',
    icon: 'terminal',
  },
  {
    key: 'user secret',
    value: 'user secret',
    text: 'User secret',
    icon: 'user secret',
  },
  {
    key: 'window close',
    value: 'window close',
    text: 'Window close',
    icon: 'window close',
  },
  {
    key: 'window close outline',
    value: 'window close outline',
    text: 'Window close outline',
    icon: 'window close outline',
  },
  {
    key: 'window maximize',
    value: 'window maximize',
    text: 'Window maximize',
    icon: 'window maximize',
  },
  {
    key: 'window maximize outline',
    value: 'window maximize outline',
    text: 'Window maximize outline',
    icon: 'window maximize outline',
  },
  {
    key: 'window minimize',
    value: 'window minimize',
    text: 'Window minimize',
    icon: 'window minimize',
  },
  {
    key: 'window minimize outline',
    value: 'window minimize outline',
    text: 'Window minimize outline',
    icon: 'window minimize outline',
  },
  {
    key: 'window restore',
    value: 'window restore',
    text: 'Window restore',
    icon: 'window restore',
  },
  {
    key: 'window restore outline',
    value: 'window restore outline',
    text: 'Window restore outline',
    icon: 'window restore outline',
  },
  {
    key: 'at',
    value: 'at',
    text: 'At',
    icon: 'at',
  },
  {
    key: 'bell',
    value: 'bell',
    text: 'Bell',
    icon: 'bell',
  },
  {
    key: 'bell outline',
    value: 'bell outline',
    text: 'Bell outline',
    icon: 'bell outline',
  },
  {
    key: 'bell slash',
    value: 'bell slash',
    text: 'Bell slash',
    icon: 'bell slash',
  },
  {
    key: 'bell slash outline',
    value: 'bell slash outline',
    text: 'Bell slash outline',
    icon: 'bell slash outline',
  },
  {
    key: 'comment',
    value: 'comment',
    text: 'Comment',
    icon: 'comment',
  },
  {
    key: 'comment outline',
    value: 'comment outline',
    text: 'Comment outline',
    icon: 'comment outline',
  },
  {
    key: 'comment alternate',
    value: 'comment alternate',
    text: 'Comment alternate',
    icon: 'comment alternate',
  },
  {
    key: 'comment alternate outline',
    value: 'comment alternate outline',
    text: 'Comment alternate outline',
    icon: 'comment alternate outline',
  },
  {
    key: 'comments',
    value: 'comments',
    text: 'Comments',
    icon: 'comments',
  },
  {
    key: 'comments outline',
    value: 'comments outline',
    text: 'Comments outline',
    icon: 'comments outline',
  },
  {
    key: 'inbox',
    value: 'inbox',
    text: 'Inbox',
    icon: 'inbox',
  },
  {
    key: 'language',
    value: 'language',
    text: 'Language',
    icon: 'language',
  },
  {
    key: 'mobile',
    value: 'mobile',
    text: 'Mobile',
    icon: 'mobile',
  },
  {
    key: 'mobile alternate',
    value: 'mobile alternate',
    text: 'Mobile alternate',
    icon: 'mobile alternate',
  },
  {
    key: 'paper plane',
    value: 'paper plane',
    text: 'Paper plane',
    icon: 'paper plane',
  },
  {
    key: 'paper plane outline',
    value: 'paper plane outline',
    text: 'Paper plane outline',
    icon: 'paper plane outline',
  },
  {
    key: 'wifi',
    value: 'wifi',
    text: 'Wifi',
    icon: 'wifi',
  },
  {
    key: 'desktop',
    value: 'desktop',
    text: 'Desktop',
    icon: 'desktop',
  },
  {
    key: 'hdd',
    value: 'hdd',
    text: 'Hdd',
    icon: 'hdd',
  },
  {
    key: 'hdd outline',
    value: 'hdd outline',
    text: 'Hdd outline',
    icon: 'hdd outline',
  },
  {
    key: 'laptop',
    value: 'laptop',
    text: 'Laptop',
    icon: 'laptop',
  },
  {
    key: 'plug',
    value: 'plug',
    text: 'Plug',
    icon: 'plug',
  },
  {
    key: 'power off',
    value: 'power off',
    text: 'Power off',
    icon: 'power off',
  },
  {
    key: 'print',
    value: 'print',
    text: 'Print',
    icon: 'print',
  },
  {
    key: 'server',
    value: 'server',
    text: 'Server',
    icon: 'server',
  },
  {
    key: 'tablet',
    value: 'tablet',
    text: 'Tablet',
    icon: 'tablet',
  },
  {
    key: 'tablet alternate',
    value: 'tablet alternate',
    text: 'Tablet alternate',
    icon: 'tablet alternate',
  },
  {
    key: 'tv',
    value: 'tv',
    text: 'Tv',
    icon: 'tv',
  },
  {
    key: 'dollar sign',
    value: 'dollar sign',
    text: 'Dollar sign',
    icon: 'dollar sign',
  },
  {
    key: 'euro sign',
    value: 'euro sign',
    text: 'Euro sign',
    icon: 'euro sign',
  },
  {
    key: 'lira sign',
    value: 'lira sign',
    text: 'Lira sign',
    icon: 'lira sign',
  },
  {
    key: 'money bill alternate',
    value: 'money bill alternate',
    text: 'Money bill alternate',
    icon: 'money bill alternate',
  },
  {
    key: 'money bill alternate outline',
    value: 'money bill alternate outline',
    text: 'Money bill alternate outline',
    icon: 'money bill alternate outline',
  },
  {
    key: 'pound sign',
    value: 'pound sign',
    text: 'Pound sign',
    icon: 'pound sign',
  },
  {
    key: 'ruble sign',
    value: 'ruble sign',
    text: 'Ruble sign',
    icon: 'ruble sign',
  },
  {
    key: 'rupee sign',
    value: 'rupee sign',
    text: 'Rupee sign',
    icon: 'rupee sign',
  },
  {
    key: 'shekel sign',
    value: 'shekel sign',
    text: 'Shekel sign',
    icon: 'shekel sign',
  },
  {
    key: 'won sign',
    value: 'won sign',
    text: 'Won sign',
    icon: 'won sign',
  },
  {
    key: 'yen sign',
    value: 'yen sign',
    text: 'Yen sign',
    icon: 'yen sign',
  },
  {
    key: 'calendar check',
    value: 'calendar check',
    text: 'Calendar check',
    icon: 'calendar check',
  },
  {
    key: 'calendar check outline',
    value: 'calendar check outline',
    text: 'Calendar check outline',
    icon: 'calendar check outline',
  },
  {
    key: 'calendar minus',
    value: 'calendar minus',
    text: 'Calendar minus',
    icon: 'calendar minus',
  },
  {
    key: 'calendar minus outline',
    value: 'calendar minus outline',
    text: 'Calendar minus outline',
    icon: 'calendar minus outline',
  },
  {
    key: 'calendar plus',
    value: 'calendar plus',
    text: 'Calendar plus',
    icon: 'calendar plus',
  },
  {
    key: 'calendar plus outline',
    value: 'calendar plus outline',
    text: 'Calendar plus outline',
    icon: 'calendar plus outline',
  },
  {
    key: 'calendar times',
    value: 'calendar times',
    text: 'Calendar times',
    icon: 'calendar times',
  },
  {
    key: 'calendar times outline',
    value: 'calendar times outline',
    text: 'Calendar times outline',
    icon: 'calendar times outline',
  },
  {
    key: 'clock',
    value: 'clock',
    text: 'Clock',
    icon: 'clock',
  },
  {
    key: 'clock outline',
    value: 'clock outline',
    text: 'Clock outline',
    icon: 'clock outline',
  },
  {
    key: 'hourglass',
    value: 'hourglass',
    text: 'Hourglass',
    icon: 'hourglass',
  },
  {
    key: 'hourglass outline',
    value: 'hourglass outline',
    text: 'Hourglass outline',
    icon: 'hourglass outline',
  },
  {
    key: 'hourglass end',
    value: 'hourglass end',
    text: 'Hourglass end',
    icon: 'hourglass end',
  },
  {
    key: 'hourglass half',
    value: 'hourglass half',
    text: 'Hourglass half',
    icon: 'hourglass half',
  },
  {
    key: 'hourglass start',
    value: 'hourglass start',
    text: 'Hourglass start',
    icon: 'hourglass start',
  },
  {
    key: 'stopwatch',
    value: 'stopwatch',
    text: 'Stopwatch',
    icon: 'stopwatch',
  },
  {
    key: 'adjust',
    value: 'adjust',
    text: 'Adjust',
    icon: 'adjust',
  },
  {
    key: 'clone',
    value: 'clone',
    text: 'Clone',
    icon: 'clone',
  },
  {
    key: 'clone outline',
    value: 'clone outline',
    text: 'Clone outline',
    icon: 'clone outline',
  },
  {
    key: 'crop',
    value: 'crop',
    text: 'Crop',
    icon: 'crop',
  },
  {
    key: 'crosshairs',
    value: 'crosshairs',
    text: 'Crosshairs',
    icon: 'crosshairs',
  },
  {
    key: 'eye',
    value: 'eye',
    text: 'Eye',
    icon: 'eye',
  },
  {
    key: 'eye dropper',
    value: 'eye dropper',
    text: 'Eye dropper',
    icon: 'eye dropper',
  },
  {
    key: 'eye slash',
    value: 'eye slash',
    text: 'Eye slash',
    icon: 'eye slash',
  },
  {
    key: 'eye slash outline',
    value: 'eye slash outline',
    text: 'Eye slash outline',
    icon: 'eye slash outline',
  },
  {
    key: 'object group',
    value: 'object group',
    text: 'Object group',
    icon: 'object group',
  },
  {
    key: 'object group outline',
    value: 'object group outline',
    text: 'Object group outline',
    icon: 'object group outline',
  },
  {
    key: 'object ungroup',
    value: 'object ungroup',
    text: 'Object ungroup',
    icon: 'object ungroup',
  },
  {
    key: 'object ungroup outline',
    value: 'object ungroup outline',
    text: 'Object ungroup outline',
    icon: 'object ungroup outline',
  },
  {
    key: 'paint brush',
    value: 'paint brush',
    text: 'Paint brush',
    icon: 'paint brush',
  },
  {
    key: 'tint',
    value: 'tint',
    text: 'Tint',
    icon: 'tint',
  },
  {
    key: 'align center',
    value: 'align center',
    text: 'Align center',
    icon: 'align center',
  },
  {
    key: 'align justify',
    value: 'align justify',
    text: 'Align justify',
    icon: 'align justify',
  },
  {
    key: 'align left',
    value: 'align left',
    text: 'Align left',
    icon: 'align left',
  },
  {
    key: 'align right',
    value: 'align right',
    text: 'Align right',
    icon: 'align right',
  },
  {
    key: 'bold',
    value: 'bold',
    text: 'Bold',
    icon: 'bold',
  },
  {
    key: 'font',
    value: 'font',
    text: 'Font',
    icon: 'font',
  },
  {
    key: 'heading',
    value: 'heading',
    text: 'Heading',
    icon: 'heading',
  },
  {
    key: 'i cursor',
    value: 'i cursor',
    text: 'I cursor',
    icon: 'i cursor',
  },
  {
    key: 'indent',
    value: 'indent',
    text: 'Indent',
    icon: 'indent',
  },
  {
    key: 'italic',
    value: 'italic',
    text: 'Italic',
    icon: 'italic',
  },
  {
    key: 'linkify',
    value: 'linkify',
    text: 'Linkify',
    icon: 'linkify',
  },
  {
    key: 'list',
    value: 'list',
    text: 'List',
    icon: 'list',
  },
  {
    key: 'list alternate',
    value: 'list alternate',
    text: 'List alternate',
    icon: 'list alternate',
  },
  {
    key: 'list alternate outline',
    value: 'list alternate outline',
    text: 'List alternate outline',
    icon: 'list alternate outline',
  },
  {
    key: 'list ol',
    value: 'list ol',
    text: 'List ol',
    icon: 'list ol',
  },
  {
    key: 'list ul',
    value: 'list ul',
    text: 'List ul',
    icon: 'list ul',
  },
  {
    key: 'outdent',
    value: 'outdent',
    text: 'Outdent',
    icon: 'outdent',
  },
  {
    key: 'paragraph',
    value: 'paragraph',
    text: 'Paragraph',
    icon: 'paragraph',
  },
  {
    key: 'quote left',
    value: 'quote left',
    text: 'Quote left',
    icon: 'quote left',
  },
  {
    key: 'quote right',
    value: 'quote right',
    text: 'Quote right',
    icon: 'quote right',
  },
  {
    key: 'strikethrough',
    value: 'strikethrough',
    text: 'Strikethrough',
    icon: 'strikethrough',
  },
  {
    key: 'subscript',
    value: 'subscript',
    text: 'Subscript',
    icon: 'subscript',
  },
  {
    key: 'superscript',
    value: 'superscript',
    text: 'Superscript',
    icon: 'superscript',
  },
  {
    key: 'th',
    value: 'th',
    text: 'Th',
    icon: 'th',
  },
  {
    key: 'th large',
    value: 'th large',
    text: 'Th large',
    icon: 'th large',
  },
  {
    key: 'th list',
    value: 'th list',
    text: 'Th list',
    icon: 'th list',
  },
  {
    key: 'trash',
    value: 'trash',
    text: 'Trash',
    icon: 'trash',
  },
  {
    key: 'trash alternate',
    value: 'trash alternate',
    text: 'Trash alternate',
    icon: 'trash alternate',
  },
  {
    key: 'trash alternate outline',
    value: 'trash alternate outline',
    text: 'Trash alternate outline',
    icon: 'trash alternate outline',
  },
  {
    key: 'underline',
    value: 'underline',
    text: 'Underline',
    icon: 'underline',
  },
  {
    key: 'unlink',
    value: 'unlink',
    text: 'Unlink',
    icon: 'unlink',
  },
  {
    key: 'file archive',
    value: 'file archive',
    text: 'File archive',
    icon: 'file archive',
  },
  {
    key: 'file archive outline',
    value: 'file archive outline',
    text: 'File archive outline',
    icon: 'file archive outline',
  },
  {
    key: 'file excel',
    value: 'file excel',
    text: 'File excel',
    icon: 'file excel',
  },
  {
    key: 'file excel outline',
    value: 'file excel outline',
    text: 'File excel outline',
    icon: 'file excel outline',
  },
  {
    key: 'file image',
    value: 'file image',
    text: 'File image',
    icon: 'file image',
  },
  {
    key: 'file image outline',
    value: 'file image outline',
    text: 'File image outline',
    icon: 'file image outline',
  },
  {
    key: 'file pdf',
    value: 'file pdf',
    text: 'File pdf',
    icon: 'file pdf',
  },
  {
    key: 'file pdf outline',
    value: 'file pdf outline',
    text: 'File pdf outline',
    icon: 'file pdf outline',
  },
  {
    key: 'file powerpoint',
    value: 'file powerpoint',
    text: 'File powerpoint',
    icon: 'file powerpoint',
  },
  {
    key: 'file powerpoint outline',
    value: 'file powerpoint outline',
    text: 'File powerpoint outline',
    icon: 'file powerpoint outline',
  },
  {
    key: 'file word',
    value: 'file word',
    text: 'File word',
    icon: 'file word',
  },
  {
    key: 'file word outline',
    value: 'file word outline',
    text: 'File word outline',
    icon: 'file word outline',
  },
  {
    key: 'genderless',
    value: 'genderless',
    text: 'Genderless',
    icon: 'genderless',
  },
  {
    key: 'mars',
    value: 'mars',
    text: 'Mars',
    icon: 'mars',
  },
  {
    key: 'mars double',
    value: 'mars double',
    text: 'Mars double',
    icon: 'mars double',
  },
  {
    key: 'mars stroke',
    value: 'mars stroke',
    text: 'Mars stroke',
    icon: 'mars stroke',
  },
  {
    key: 'mars stroke horizontal',
    value: 'mars stroke horizontal',
    text: 'Mars stroke horizontal',
    icon: 'mars stroke horizontal',
  },
  {
    key: 'mars stroke vertical',
    value: 'mars stroke vertical',
    text: 'Mars stroke vertical',
    icon: 'mars stroke vertical',
  },
  {
    key: 'mercury',
    value: 'mercury',
    text: 'Mercury',
    icon: 'mercury',
  },
  {
    key: 'neuter',
    value: 'neuter',
    text: 'Neuter',
    icon: 'neuter',
  },
  {
    key: 'transgender',
    value: 'transgender',
    text: 'Transgender',
    icon: 'transgender',
  },
  {
    key: 'transgender alternate',
    value: 'transgender alternate',
    text: 'Transgender alternate',
    icon: 'transgender alternate',
  },
  {
    key: 'venus',
    value: 'venus',
    text: 'Venus',
    icon: 'venus',
  },
  {
    key: 'venus double',
    value: 'venus double',
    text: 'Venus double',
    icon: 'venus double',
  },
  {
    key: 'venus mars',
    value: 'venus mars',
    text: 'Venus mars',
    icon: 'venus mars',
  },
  {
    key: 'hand lizard',
    value: 'hand lizard',
    text: 'Hand lizard',
    icon: 'hand lizard',
  },
  {
    key: 'hand lizard outline',
    value: 'hand lizard outline',
    text: 'Hand lizard outline',
    icon: 'hand lizard outline',
  },
  {
    key: 'hand paper',
    value: 'hand paper',
    text: 'Hand paper',
    icon: 'hand paper',
  },
  {
    key: 'hand paper outline',
    value: 'hand paper outline',
    text: 'Hand paper outline',
    icon: 'hand paper outline',
  },
  {
    key: 'hand peace',
    value: 'hand peace',
    text: 'Hand peace',
    icon: 'hand peace',
  },
  {
    key: 'hand peace outline',
    value: 'hand peace outline',
    text: 'Hand peace outline',
    icon: 'hand peace outline',
  },
  {
    key: 'hand rock',
    value: 'hand rock',
    text: 'Hand rock',
    icon: 'hand rock',
  },
  {
    key: 'hand rock outline',
    value: 'hand rock outline',
    text: 'Hand rock outline',
    icon: 'hand rock outline',
  },
  {
    key: 'hand scissors',
    value: 'hand scissors',
    text: 'Hand scissors',
    icon: 'hand scissors',
  },
  {
    key: 'hand scissors outline',
    value: 'hand scissors outline',
    text: 'Hand scissors outline',
    icon: 'hand scissors outline',
  },
  {
    key: 'hand spock',
    value: 'hand spock',
    text: 'Hand spock',
    icon: 'hand spock',
  },
  {
    key: 'hand spock outline',
    value: 'hand spock outline',
    text: 'Hand spock outline',
    icon: 'hand spock outline',
  },
  {
    key: 'handshake',
    value: 'handshake',
    text: 'Handshake',
    icon: 'handshake',
  },
  {
    key: 'handshake outline',
    value: 'handshake outline',
    text: 'Handshake outline',
    icon: 'handshake outline',
  },
  {
    key: 'thumbs down',
    value: 'thumbs down',
    text: 'Thumbs down',
    icon: 'thumbs down',
  },
  {
    key: 'thumbs down outline',
    value: 'thumbs down outline',
    text: 'Thumbs down outline',
    icon: 'thumbs down outline',
  },
  {
    key: 'thumbs up',
    value: 'thumbs up',
    text: 'Thumbs up',
    icon: 'thumbs up',
  },
  {
    key: 'thumbs up outline',
    value: 'thumbs up outline',
    text: 'Thumbs up outline',
    icon: 'thumbs up outline',
  },
  {
    key: 'ambulance',
    value: 'ambulance',
    text: 'Ambulance',
    icon: 'ambulance',
  },
  {
    key: 'h square',
    value: 'h square',
    text: 'H square',
    icon: 'h square',
  },
  {
    key: 'heart',
    value: 'heart',
    text: 'Heart',
    icon: 'heart',
  },
  {
    key: 'heart outline',
    value: 'heart outline',
    text: 'Heart outline',
    icon: 'heart outline',
  },
  {
    key: 'heartbeat',
    value: 'heartbeat',
    text: 'Heartbeat',
    icon: 'heartbeat',
  },
  {
    key: 'hospital',
    value: 'hospital',
    text: 'Hospital',
    icon: 'hospital',
  },
  {
    key: 'hospital outline',
    value: 'hospital outline',
    text: 'Hospital outline',
    icon: 'hospital outline',
  },
  {
    key: 'medkit',
    value: 'medkit',
    text: 'Medkit',
    icon: 'medkit',
  },
  {
    key: 'plus square',
    value: 'plus square',
    text: 'Plus square',
    icon: 'plus square',
  },
  {
    key: 'plus square outline',
    value: 'plus square outline',
    text: 'Plus square outline',
    icon: 'plus square outline',
  },
  {
    key: 'stethoscope',
    value: 'stethoscope',
    text: 'Stethoscope',
    icon: 'stethoscope',
  },
  {
    key: 'user md',
    value: 'user md',
    text: 'User md',
    icon: 'user md',
  },
  {
    key: 'bolt',
    value: 'bolt',
    text: 'Bolt',
    icon: 'bolt',
  },
  {
    key: 'camera',
    value: 'camera',
    text: 'Camera',
    icon: 'camera',
  },
  {
    key: 'camera retro',
    value: 'camera retro',
    text: 'Camera retro',
    icon: 'camera retro',
  },
  {
    key: 'id badge',
    value: 'id badge',
    text: 'Id badge',
    icon: 'id badge',
  },
  {
    key: 'id badge outline',
    value: 'id badge outline',
    text: 'Id badge outline',
    icon: 'id badge outline',
  },
  {
    key: 'id card',
    value: 'id card',
    text: 'Id card',
    icon: 'id card',
  },
  {
    key: 'id card outline',
    value: 'id card outline',
    text: 'Id card outline',
    icon: 'id card outline',
  },
  {
    key: 'image',
    value: 'image',
    text: 'Image',
    icon: 'image',
  },
  {
    key: 'image outline',
    value: 'image outline',
    text: 'Image outline',
    icon: 'image outline',
  },
  {
    key: 'images',
    value: 'images',
    text: 'Images',
    icon: 'images',
  },
  {
    key: 'images outline',
    value: 'images outline',
    text: 'Images outline',
    icon: 'images outline',
  },
  {
    key: 'sliders horizontal',
    value: 'sliders horizontal',
    text: 'Sliders horizontal',
    icon: 'sliders horizontal',
  },
  {
    key: 'ban',
    value: 'ban',
    text: 'Ban',
    icon: 'ban',
  },
  {
    key: 'bars',
    value: 'bars',
    text: 'Bars',
    icon: 'bars',
  },
  {
    key: 'beer',
    value: 'beer',
    text: 'Beer',
    icon: 'beer',
  },
  {
    key: 'check',
    value: 'check',
    text: 'Check',
    icon: 'check',
  },
  {
    key: 'check circle',
    value: 'check circle',
    text: 'Check circle',
    icon: 'check circle',
  },
  {
    key: 'check circle outline',
    value: 'check circle outline',
    text: 'Check circle outline',
    icon: 'check circle outline',
  },
  {
    key: 'check square',
    value: 'check square',
    text: 'Check square',
    icon: 'check square',
  },
  {
    key: 'check square outline',
    value: 'check square outline',
    text: 'Check square outline',
    icon: 'check square outline',
  },
  {
    key: 'cloud',
    value: 'cloud',
    text: 'Cloud',
    icon: 'cloud',
  },
  {
    key: 'cog',
    value: 'cog',
    text: 'Cog',
    icon: 'cog',
  },
  {
    key: 'cogs',
    value: 'cogs',
    text: 'Cogs',
    icon: 'cogs',
  },
  {
    key: 'database',
    value: 'database',
    text: 'Database',
    icon: 'database',
  },
  {
    key: 'dot circle',
    value: 'dot circle',
    text: 'Dot circle',
    icon: 'dot circle',
  },
  {
    key: 'dot circle outline',
    value: 'dot circle outline',
    text: 'Dot circle outline',
    icon: 'dot circle outline',
  },
  {
    key: 'ellipsis horizontal',
    value: 'ellipsis horizontal',
    text: 'Ellipsis horizontal',
    icon: 'ellipsis horizontal',
  },
  {
    key: 'ellipsis vertical',
    value: 'ellipsis vertical',
    text: 'Ellipsis vertical',
    icon: 'ellipsis vertical',
  },
  {
    key: 'exclamation',
    value: 'exclamation',
    text: 'Exclamation',
    icon: 'exclamation',
  },
  {
    key: 'exclamation circle',
    value: 'exclamation circle',
    text: 'Exclamation circle',
    icon: 'exclamation circle',
  },
  {
    key: 'exclamation triangle',
    value: 'exclamation triangle',
    text: 'Exclamation triangle',
    icon: 'exclamation triangle',
  },
  {
    key: 'flag',
    value: 'flag',
    text: 'Flag',
    icon: 'flag',
  },
  {
    key: 'flag outline',
    value: 'flag outline',
    text: 'Flag outline',
    icon: 'flag outline',
  },
  {
    key: 'flag checkered',
    value: 'flag checkered',
    text: 'Flag checkered',
    icon: 'flag checkered',
  },
  {
    key: 'frown',
    value: 'frown',
    text: 'Frown',
    icon: 'frown',
  },
  {
    key: 'frown outline',
    value: 'frown outline',
    text: 'Frown outline',
    icon: 'frown outline',
  },
  {
    key: 'hashtag',
    value: 'hashtag',
    text: 'Hashtag',
    icon: 'hashtag',
  },
  {
    key: 'home',
    value: 'home',
    text: 'Home',
    icon: 'home',
  },
  {
    key: 'info',
    value: 'info',
    text: 'Info',
    icon: 'info',
  },
  {
    key: 'info circle',
    value: 'info circle',
    text: 'Info circle',
    icon: 'info circle',
  },
  {
    key: 'magic',
    value: 'magic',
    text: 'Magic',
    icon: 'magic',
  },
  {
    key: 'meh',
    value: 'meh',
    text: 'Meh',
    icon: 'meh',
  },
  {
    key: 'meh outline',
    value: 'meh outline',
    text: 'Meh outline',
    icon: 'meh outline',
  },
  {
    key: 'minus',
    value: 'minus',
    text: 'Minus',
    icon: 'minus',
  },
  {
    key: 'minus circle',
    value: 'minus circle',
    text: 'Minus circle',
    icon: 'minus circle',
  },
  {
    key: 'minus square',
    value: 'minus square',
    text: 'Minus square',
    icon: 'minus square',
  },
  {
    key: 'minus square outline',
    value: 'minus square outline',
    text: 'Minus square outline',
    icon: 'minus square outline',
  },
  {
    key: 'plus',
    value: 'plus',
    text: 'Plus',
    icon: 'plus',
  },
  {
    key: 'plus circle',
    value: 'plus circle',
    text: 'Plus circle',
    icon: 'plus circle',
  },
  {
    key: 'question',
    value: 'question',
    text: 'Question',
    icon: 'question',
  },
  {
    key: 'search',
    value: 'search',
    text: 'Search',
    icon: 'search',
  },
  {
    key: 'search minus',
    value: 'search minus',
    text: 'Search minus',
    icon: 'search minus',
  },
  {
    key: 'search plus',
    value: 'search plus',
    text: 'Search plus',
    icon: 'search plus',
  },
  {
    key: 'share alternate',
    value: 'share alternate',
    text: 'Share alternate',
    icon: 'share alternate',
  },
  {
    key: 'share alternate square',
    value: 'share alternate square',
    text: 'Share alternate square',
    icon: 'share alternate square',
  },
  {
    key: 'signal',
    value: 'signal',
    text: 'Signal',
    icon: 'signal',
  },
  {
    key: 'smile',
    value: 'smile',
    text: 'Smile',
    icon: 'smile',
  },
  {
    key: 'smile outline',
    value: 'smile outline',
    text: 'Smile outline',
    icon: 'smile outline',
  },
  {
    key: 'star',
    value: 'star',
    text: 'Star',
    icon: 'star',
  },
  {
    key: 'star outline',
    value: 'star outline',
    text: 'Star outline',
    icon: 'star outline',
  },
  {
    key: 'star half',
    value: 'star half',
    text: 'Star half',
    icon: 'star half',
  },
  {
    key: 'star half outline',
    value: 'star half outline',
    text: 'Star half outline',
    icon: 'star half outline',
  },
  {
    key: 'times',
    value: 'times',
    text: 'Times',
    icon: 'times',
  },
  {
    key: 'times circle',
    value: 'times circle',
    text: 'Times circle',
    icon: 'times circle',
  },
  {
    key: 'times circle outline',
    value: 'times circle outline',
    text: 'Times circle outline',
    icon: 'times circle outline',
  },
  {
    key: 'toggle off',
    value: 'toggle off',
    text: 'Toggle off',
    icon: 'toggle off',
  },
  {
    key: 'toggle on',
    value: 'toggle on',
    text: 'Toggle on',
    icon: 'toggle on',
  },
  {
    key: 'trophy',
    value: 'trophy',
    text: 'Trophy',
    icon: 'trophy',
  },
  {
    key: 'user',
    value: 'user',
    text: 'User',
    icon: 'user',
  },
  {
    key: 'user outline',
    value: 'user outline',
    text: 'User outline',
    icon: 'user outline',
  },
  {
    key: 'user circle',
    value: 'user circle',
    text: 'User circle',
    icon: 'user circle',
  },
  {
    key: 'user circle outline',
    value: 'user circle outline',
    text: 'User circle outline',
    icon: 'user circle outline',
  },
  {
    key: 'box',
    value: 'box',
    text: 'Box',
    icon: 'box',
  },
  {
    key: 'boxes',
    value: 'boxes',
    text: 'Boxes',
    icon: 'boxes',
  },
  {
    key: 'clipboard check',
    value: 'clipboard check',
    text: 'Clipboard check',
    icon: 'clipboard check',
  },
  {
    key: 'clipboard list',
    value: 'clipboard list',
    text: 'Clipboard list',
    icon: 'clipboard list',
  },
  {
    key: 'dolly',
    value: 'dolly',
    text: 'Dolly',
    icon: 'dolly',
  },
  {
    key: 'dolly flatbed',
    value: 'dolly flatbed',
    text: 'Dolly flatbed',
    icon: 'dolly flatbed',
  },
  {
    key: 'pallet',
    value: 'pallet',
    text: 'Pallet',
    icon: 'pallet',
  },
  {
    key: 'shipping fast',
    value: 'shipping fast',
    text: 'Shipping fast',
    icon: 'shipping fast',
  },
  {
    key: 'truck',
    value: 'truck',
    text: 'Truck',
    icon: 'truck',
  },
  {
    key: 'warehouse',
    value: 'warehouse',
    text: 'Warehouse',
    icon: 'warehouse',
  },
  {
    key: 'anchor',
    value: 'anchor',
    text: 'Anchor',
    icon: 'anchor',
  },
  {
    key: 'bed',
    value: 'bed',
    text: 'Bed',
    icon: 'bed',
  },
  {
    key: 'bicycle',
    value: 'bicycle',
    text: 'Bicycle',
    icon: 'bicycle',
  },
  {
    key: 'binoculars',
    value: 'binoculars',
    text: 'Binoculars',
    icon: 'binoculars',
  },
  {
    key: 'bomb',
    value: 'bomb',
    text: 'Bomb',
    icon: 'bomb',
  },
  {
    key: 'bookmark',
    value: 'bookmark',
    text: 'Bookmark',
    icon: 'bookmark',
  },
  {
    key: 'bookmark outline',
    value: 'bookmark outline',
    text: 'Bookmark outline',
    icon: 'bookmark outline',
  },
  {
    key: 'car',
    value: 'car',
    text: 'Car',
    icon: 'car',
  },
  {
    key: 'fighter jet',
    value: 'fighter jet',
    text: 'Fighter jet',
    icon: 'fighter jet',
  },
  {
    key: 'fire',
    value: 'fire',
    text: 'Fire',
    icon: 'fire',
  },
  {
    key: 'flask',
    value: 'flask',
    text: 'Flask',
    icon: 'flask',
  },
  {
    key: 'gamepad',
    value: 'gamepad',
    text: 'Gamepad',
    icon: 'gamepad',
  },
  {
    key: 'gavel',
    value: 'gavel',
    text: 'Gavel',
    icon: 'gavel',
  },
  {
    key: 'gift',
    value: 'gift',
    text: 'Gift',
    icon: 'gift',
  },
  {
    key: 'glass martini',
    value: 'glass martini',
    text: 'Glass martini',
    icon: 'glass martini',
  },
  {
    key: 'graduation cap',
    value: 'graduation cap',
    text: 'Graduation cap',
    icon: 'graduation cap',
  },
  {
    key: 'key',
    value: 'key',
    text: 'Key',
    icon: 'key',
  },
  {
    key: 'leaf',
    value: 'leaf',
    text: 'Leaf',
    icon: 'leaf',
  },
  {
    key: 'lemon',
    value: 'lemon',
    text: 'Lemon',
    icon: 'lemon',
  },
  {
    key: 'lemon outline',
    value: 'lemon outline',
    text: 'Lemon outline',
    icon: 'lemon outline',
  },
  {
    key: 'life ring',
    value: 'life ring',
    text: 'Life ring',
    icon: 'life ring',
  },
  {
    key: 'life ring outline',
    value: 'life ring outline',
    text: 'Life ring outline',
    icon: 'life ring outline',
  },
  {
    key: 'lightbulb',
    value: 'lightbulb',
    text: 'Lightbulb',
    icon: 'lightbulb',
  },
  {
    key: 'lightbulb outline',
    value: 'lightbulb outline',
    text: 'Lightbulb outline',
    icon: 'lightbulb outline',
  },
  {
    key: 'magnet',
    value: 'magnet',
    text: 'Magnet',
    icon: 'magnet',
  },
  {
    key: 'male',
    value: 'male',
    text: 'Male',
    icon: 'male',
  },
  {
    key: 'map',
    value: 'map',
    text: 'Map',
    icon: 'map',
  },
  {
    key: 'map outline',
    value: 'map outline',
    text: 'Map outline',
    icon: 'map outline',
  },
  {
    key: 'map marker',
    value: 'map marker',
    text: 'Map marker',
    icon: 'map marker',
  },
  {
    key: 'map marker alternate',
    value: 'map marker alternate',
    text: 'Map marker alternate',
    icon: 'map marker alternate',
  },
  {
    key: 'map pin',
    value: 'map pin',
    text: 'Map pin',
    icon: 'map pin',
  },
  {
    key: 'map signs',
    value: 'map signs',
    text: 'Map signs',
    icon: 'map signs',
  },
  {
    key: 'motorcycle',
    value: 'motorcycle',
    text: 'Motorcycle',
    icon: 'motorcycle',
  },
  {
    key: 'newspaper',
    value: 'newspaper',
    text: 'Newspaper',
    icon: 'newspaper',
  },
  {
    key: 'newspaper outline',
    value: 'newspaper outline',
    text: 'Newspaper outline',
    icon: 'newspaper outline',
  },
  {
    key: 'paw',
    value: 'paw',
    text: 'Paw',
    icon: 'paw',
  },
  {
    key: 'plane',
    value: 'plane',
    text: 'Plane',
    icon: 'plane',
  },
  {
    key: 'road',
    value: 'road',
    text: 'Road',
    icon: 'road',
  },
  {
    key: 'rocket',
    value: 'rocket',
    text: 'Rocket',
    icon: 'rocket',
  },
  {
    key: 'ship',
    value: 'ship',
    text: 'Ship',
    icon: 'ship',
  },
  {
    key: 'shopping bag',
    value: 'shopping bag',
    text: 'Shopping bag',
    icon: 'shopping bag',
  },
  {
    key: 'shopping basket',
    value: 'shopping basket',
    text: 'Shopping basket',
    icon: 'shopping basket',
  },
  {
    key: 'shopping cart',
    value: 'shopping cart',
    text: 'Shopping cart',
    icon: 'shopping cart',
  },
  {
    key: 'shower',
    value: 'shower',
    text: 'Shower',
    icon: 'shower',
  },
  {
    key: 'street view',
    value: 'street view',
    text: 'Street view',
    icon: 'street view',
  },
  {
    key: 'subway',
    value: 'subway',
    text: 'Subway',
    icon: 'subway',
  },
  {
    key: 'taxi',
    value: 'taxi',
    text: 'Taxi',
    icon: 'taxi',
  },
  {
    key: 'ticket alternate',
    value: 'ticket alternate',
    text: 'Ticket alternate',
    icon: 'ticket alternate',
  },
  {
    key: 'train',
    value: 'train',
    text: 'Train',
    icon: 'train',
  },
  {
    key: 'tree',
    value: 'tree',
    text: 'Tree',
    icon: 'tree',
  },
  {
    key: 'umbrella',
    value: 'umbrella',
    text: 'Umbrella',
    icon: 'umbrella',
  },
  {
    key: 'university',
    value: 'university',
    text: 'University',
    icon: 'university',
  },
  {
    key: 'utensil spoon',
    value: 'utensil spoon',
    text: 'Utensil spoon',
    icon: 'utensil spoon',
  },
  {
    key: 'utensils',
    value: 'utensils',
    text: 'Utensils',
    icon: 'utensils',
  },
  {
    key: 'wrench',
    value: 'wrench',
    text: 'Wrench',
    icon: 'wrench',
  },
  {
    key: 'band aid',
    value: 'band aid',
    text: 'Band aid',
    icon: 'band aid',
  },
  {
    key: 'dna',
    value: 'dna',
    text: 'Dna',
    icon: 'dna',
  },
  {
    key: 'first aid',
    value: 'first aid',
    text: 'First aid',
    icon: 'first aid',
  },
  {
    key: 'hospital symbol',
    value: 'hospital symbol',
    text: 'Hospital symbol',
    icon: 'hospital symbol',
  },
  {
    key: 'pills',
    value: 'pills',
    text: 'Pills',
    icon: 'pills',
  },
  {
    key: 'syringe',
    value: 'syringe',
    text: 'Syringe',
    icon: 'syringe',
  },
  {
    key: 'thermometer',
    value: 'thermometer',
    text: 'Thermometer',
    icon: 'thermometer',
  },
  {
    key: 'weight',
    value: 'weight',
    text: 'Weight',
    icon: 'weight',
  },
  {
    key: 'bus',
    value: 'bus',
    text: 'Bus',
    icon: 'bus',
  },
  {
    key: 'cube',
    value: 'cube',
    text: 'Cube',
    icon: 'cube',
  },
  {
    key: 'cubes',
    value: 'cubes',
    text: 'Cubes',
    icon: 'cubes',
  },
  {
    key: 'futbol',
    value: 'futbol',
    text: 'Futbol',
    icon: 'futbol',
  },
  {
    key: 'futbol outline',
    value: 'futbol outline',
    text: 'Futbol outline',
    icon: 'futbol outline',
  },
  {
    key: 'gem',
    value: 'gem',
    text: 'Gem',
    icon: 'gem',
  },
  {
    key: 'gem outline',
    value: 'gem outline',
    text: 'Gem outline',
    icon: 'gem outline',
  },
  {
    key: 'lock',
    value: 'lock',
    text: 'Lock',
    icon: 'lock',
  },
  {
    key: 'lock open',
    value: 'lock open',
    text: 'Lock open',
    icon: 'lock open',
  },
  {
    key: 'moon',
    value: 'moon',
    text: 'Moon',
    icon: 'moon',
  },
  {
    key: 'moon outline',
    value: 'moon outline',
    text: 'Moon outline',
    icon: 'moon outline',
  },
  {
    key: 'puzzle piece',
    value: 'puzzle piece',
    text: 'Puzzle piece',
    icon: 'puzzle piece',
  },
  {
    key: 'snowflake',
    value: 'snowflake',
    text: 'Snowflake',
    icon: 'snowflake',
  },
  {
    key: 'snowflake outline',
    value: 'snowflake outline',
    text: 'Snowflake outline',
    icon: 'snowflake outline',
  },
  {
    key: 'space shuttle',
    value: 'space shuttle',
    text: 'Space shuttle',
    icon: 'space shuttle',
  },
  {
    key: 'sun',
    value: 'sun',
    text: 'Sun',
    icon: 'sun',
  },
  {
    key: 'sun outline',
    value: 'sun outline',
    text: 'Sun outline',
    icon: 'sun outline',
  },
  {
    key: 'tachometer alternate',
    value: 'tachometer alternate',
    text: 'Tachometer alternate',
    icon: 'tachometer alternate',
  },
  {
    key: 'unlock',
    value: 'unlock',
    text: 'Unlock',
    icon: 'unlock',
  },
  {
    key: 'unlock alternate',
    value: 'unlock alternate',
    text: 'Unlock alternate',
    icon: 'unlock alternate',
  },
  {
    key: 'cart plus',
    value: 'cart plus',
    text: 'Cart plus',
    icon: 'cart plus',
  },
  {
    key: 'credit card',
    value: 'credit card',
    text: 'Credit card',
    icon: 'credit card',
  },
  {
    key: 'credit card outline',
    value: 'credit card outline',
    text: 'Credit card outline',
    icon: 'credit card outline',
  },
  {
    key: 'square',
    value: 'square',
    text: 'Square',
    icon: 'square',
  },
  {
    key: 'square outline',
    value: 'square outline',
    text: 'Square outline',
    icon: 'square outline',
  },
  {
    key: 'asterisk',
    value: 'asterisk',
    text: 'Asterisk',
    icon: 'asterisk',
  },
  {
    key: 'circle notch',
    value: 'circle notch',
    text: 'Circle notch',
    icon: 'circle notch',
  },
  {
    key: 'spinner',
    value: 'spinner',
    text: 'Spinner',
    icon: 'spinner',
  },
  {
    key: 'baseball ball',
    value: 'baseball ball',
    text: 'Baseball ball',
    icon: 'baseball ball',
  },
  {
    key: 'basketball ball',
    value: 'basketball ball',
    text: 'Basketball ball',
    icon: 'basketball ball',
  },
  {
    key: 'bowling ball',
    value: 'bowling ball',
    text: 'Bowling ball',
    icon: 'bowling ball',
  },
  {
    key: 'football ball',
    value: 'football ball',
    text: 'Football ball',
    icon: 'football ball',
  },
  {
    key: 'golf ball',
    value: 'golf ball',
    text: 'Golf ball',
    icon: 'golf ball',
  },
  {
    key: 'hockey puck',
    value: 'hockey puck',
    text: 'Hockey puck',
    icon: 'hockey puck',
  },
  {
    key: 'quidditch',
    value: 'quidditch',
    text: 'Quidditch',
    icon: 'quidditch',
  },
  {
    key: 'table tennis',
    value: 'table tennis',
    text: 'Table tennis',
    icon: 'table tennis',
  },
  {
    key: 'volleyball ball',
    value: 'volleyball ball',
    text: 'Volleyball ball',
    icon: 'volleyball ball',
  },
  {
    key: 'battery empty',
    value: 'battery empty',
    text: 'Battery empty',
    icon: 'battery empty',
  },
  {
    key: 'battery full',
    value: 'battery full',
    text: 'Battery full',
    icon: 'battery full',
  },
  {
    key: 'battery half',
    value: 'battery half',
    text: 'Battery half',
    icon: 'battery half',
  },
  {
    key: 'battery quarter',
    value: 'battery quarter',
    text: 'Battery quarter',
    icon: 'battery quarter',
  },
  {
    key: 'battery three quarters',
    value: 'battery three quarters',
    text: 'Battery three quarters',
    icon: 'battery three quarters',
  },
  {
    key: 'sign in alternate',
    value: 'sign in alternate',
    text: 'Sign in alternate',
    icon: 'sign in alternate',
  },
  {
    key: 'sign out alternate',
    value: 'sign out alternate',
    text: 'Sign out alternate',
    icon: 'sign out alternate',
  },
  {
    key: 'thermometer empty',
    value: 'thermometer empty',
    text: 'Thermometer empty',
    icon: 'thermometer empty',
  },
  {
    key: 'thermometer full',
    value: 'thermometer full',
    text: 'Thermometer full',
    icon: 'thermometer full',
  },
  {
    key: 'thermometer half',
    value: 'thermometer half',
    text: 'Thermometer half',
    icon: 'thermometer half',
  },
  {
    key: 'thermometer quarter',
    value: 'thermometer quarter',
    text: 'Thermometer quarter',
    icon: 'thermometer quarter',
  },
  {
    key: 'thermometer three quarters',
    value: 'thermometer three quarters',
    text: 'Thermometer three quarters',
    icon: 'thermometer three quarters',
  },
  {
    key: 'child',
    value: 'child',
    text: 'Child',
    icon: 'child',
  },
  {
    key: 'female',
    value: 'female',
    text: 'Female',
    icon: 'female',
  },
  {
    key: 'user plus',
    value: 'user plus',
    text: 'User plus',
    icon: 'user plus',
  },
  {
    key: 'user times',
    value: 'user times',
    text: 'User times',
    icon: 'user times',
  },
  {
    key: 'users',
    value: 'users',
    text: 'Users',
    icon: 'users',
  },
  {
    key: '500px',
    value: '500px',
    text: '500px',
    icon: '500px',
  },
  {
    key: 'accessible',
    value: 'accessible',
    text: 'Accessible',
    icon: 'accessible',
  },
  {
    key: 'accusoft',
    value: 'accusoft',
    text: 'Accusoft',
    icon: 'accusoft',
  },
  {
    key: 'adn',
    value: 'adn',
    text: 'Adn',
    icon: 'adn',
  },
  {
    key: 'adversal',
    value: 'adversal',
    text: 'Adversal',
    icon: 'adversal',
  },
  {
    key: 'affiliatetheme',
    value: 'affiliatetheme',
    text: 'Affiliatetheme',
    icon: 'affiliatetheme',
  },
  {
    key: 'algolia',
    value: 'algolia',
    text: 'Algolia',
    icon: 'algolia',
  },
  {
    key: 'amazon',
    value: 'amazon',
    text: 'Amazon',
    icon: 'amazon',
  },
  {
    key: 'amazon pay',
    value: 'amazon pay',
    text: 'Amazon pay',
    icon: 'amazon pay',
  },
  {
    key: 'amilia',
    value: 'amilia',
    text: 'Amilia',
    icon: 'amilia',
  },
  {
    key: 'android',
    value: 'android',
    text: 'Android',
    icon: 'android',
  },
  {
    key: 'angellist',
    value: 'angellist',
    text: 'Angellist',
    icon: 'angellist',
  },
  {
    key: 'angrycreative',
    value: 'angrycreative',
    text: 'Angrycreative',
    icon: 'angrycreative',
  },
  {
    key: 'angular',
    value: 'angular',
    text: 'Angular',
    icon: 'angular',
  },
  {
    key: 'app store',
    value: 'app store',
    text: 'App store',
    icon: 'app store',
  },
  {
    key: 'app store ios',
    value: 'app store ios',
    text: 'App store ios',
    icon: 'app store ios',
  },
  {
    key: 'apper',
    value: 'apper',
    text: 'Apper',
    icon: 'apper',
  },
  {
    key: 'apple',
    value: 'apple',
    text: 'Apple',
    icon: 'apple',
  },
  {
    key: 'apple pay',
    value: 'apple pay',
    text: 'Apple pay',
    icon: 'apple pay',
  },
  {
    key: 'asymmetrik',
    value: 'asymmetrik',
    text: 'Asymmetrik',
    icon: 'asymmetrik',
  },
  {
    key: 'audible',
    value: 'audible',
    text: 'Audible',
    icon: 'audible',
  },
  {
    key: 'autoprefixer',
    value: 'autoprefixer',
    text: 'Autoprefixer',
    icon: 'autoprefixer',
  },
  {
    key: 'avianex',
    value: 'avianex',
    text: 'Avianex',
    icon: 'avianex',
  },
  {
    key: 'aviato',
    value: 'aviato',
    text: 'Aviato',
    icon: 'aviato',
  },
  {
    key: 'aws',
    value: 'aws',
    text: 'Aws',
    icon: 'aws',
  },
  {
    key: 'bandcamp',
    value: 'bandcamp',
    text: 'Bandcamp',
    icon: 'bandcamp',
  },
  {
    key: 'behance',
    value: 'behance',
    text: 'Behance',
    icon: 'behance',
  },
  {
    key: 'behance square',
    value: 'behance square',
    text: 'Behance square',
    icon: 'behance square',
  },
  {
    key: 'bimobject',
    value: 'bimobject',
    text: 'Bimobject',
    icon: 'bimobject',
  },
  {
    key: 'bitbucket',
    value: 'bitbucket',
    text: 'Bitbucket',
    icon: 'bitbucket',
  },
  {
    key: 'bitcoin',
    value: 'bitcoin',
    text: 'Bitcoin',
    icon: 'bitcoin',
  },
  {
    key: 'bity',
    value: 'bity',
    text: 'Bity',
    icon: 'bity',
  },
  {
    key: 'black tie',
    value: 'black tie',
    text: 'Black tie',
    icon: 'black tie',
  },
  {
    key: 'blackberry',
    value: 'blackberry',
    text: 'Blackberry',
    icon: 'blackberry',
  },
  {
    key: 'blogger',
    value: 'blogger',
    text: 'Blogger',
    icon: 'blogger',
  },
  {
    key: 'blogger b',
    value: 'blogger b',
    text: 'Blogger b',
    icon: 'blogger b',
  },
  {
    key: 'bluetooth',
    value: 'bluetooth',
    text: 'Bluetooth',
    icon: 'bluetooth',
  },
  {
    key: 'bluetooth b',
    value: 'bluetooth b',
    text: 'Bluetooth b',
    icon: 'bluetooth b',
  },
  {
    key: 'btc',
    value: 'btc',
    text: 'Btc',
    icon: 'btc',
  },
  {
    key: 'buromobelexperte',
    value: 'buromobelexperte',
    text: 'Buromobelexperte',
    icon: 'buromobelexperte',
  },
  {
    key: 'buysellads',
    value: 'buysellads',
    text: 'Buysellads',
    icon: 'buysellads',
  },
  {
    key: 'cc amazon pay',
    value: 'cc amazon pay',
    text: 'Cc amazon pay',
    icon: 'cc amazon pay',
  },
  {
    key: 'cc amex',
    value: 'cc amex',
    text: 'Cc amex',
    icon: 'cc amex',
  },
  {
    key: 'cc apple pay',
    value: 'cc apple pay',
    text: 'Cc apple pay',
    icon: 'cc apple pay',
  },
  {
    key: 'cc diners club',
    value: 'cc diners club',
    text: 'Cc diners club',
    icon: 'cc diners club',
  },
  {
    key: 'cc discover',
    value: 'cc discover',
    text: 'Cc discover',
    icon: 'cc discover',
  },
  {
    key: 'cc jcb',
    value: 'cc jcb',
    text: 'Cc jcb',
    icon: 'cc jcb',
  },
  {
    key: 'cc mastercard',
    value: 'cc mastercard',
    text: 'Cc mastercard',
    icon: 'cc mastercard',
  },
  {
    key: 'cc paypal',
    value: 'cc paypal',
    text: 'Cc paypal',
    icon: 'cc paypal',
  },
  {
    key: 'cc stripe',
    value: 'cc stripe',
    text: 'Cc stripe',
    icon: 'cc stripe',
  },
  {
    key: 'cc visa',
    value: 'cc visa',
    text: 'Cc visa',
    icon: 'cc visa',
  },
  {
    key: 'centercode',
    value: 'centercode',
    text: 'Centercode',
    icon: 'centercode',
  },
  {
    key: 'chrome',
    value: 'chrome',
    text: 'Chrome',
    icon: 'chrome',
  },
  {
    key: 'cloudscale',
    value: 'cloudscale',
    text: 'Cloudscale',
    icon: 'cloudscale',
  },
  {
    key: 'cloudsmith',
    value: 'cloudsmith',
    text: 'Cloudsmith',
    icon: 'cloudsmith',
  },
  {
    key: 'cloudversify',
    value: 'cloudversify',
    text: 'Cloudversify',
    icon: 'cloudversify',
  },
  {
    key: 'codepen',
    value: 'codepen',
    text: 'Codepen',
    icon: 'codepen',
  },
  {
    key: 'codiepie',
    value: 'codiepie',
    text: 'Codiepie',
    icon: 'codiepie',
  },
  {
    key: 'connectdevelop',
    value: 'connectdevelop',
    text: 'Connectdevelop',
    icon: 'connectdevelop',
  },
  {
    key: 'contao',
    value: 'contao',
    text: 'Contao',
    icon: 'contao',
  },
  {
    key: 'cpanel',
    value: 'cpanel',
    text: 'Cpanel',
    icon: 'cpanel',
  },
  {
    key: 'creative commons',
    value: 'creative commons',
    text: 'Creative commons',
    icon: 'creative commons',
  },
  {
    key: 'css3',
    value: 'css3',
    text: 'Css3',
    icon: 'css3',
  },
  {
    key: 'css3 alternate',
    value: 'css3 alternate',
    text: 'Css3 alternate',
    icon: 'css3 alternate',
  },
  {
    key: 'cuttlefish',
    value: 'cuttlefish',
    text: 'Cuttlefish',
    icon: 'cuttlefish',
  },
  {
    key: 'd and d',
    value: 'd and d',
    text: 'D and d',
    icon: 'd and d',
  },
  {
    key: 'dashcube',
    value: 'dashcube',
    text: 'Dashcube',
    icon: 'dashcube',
  },
  {
    key: 'delicious',
    value: 'delicious',
    text: 'Delicious',
    icon: 'delicious',
  },
  {
    key: 'deploydog',
    value: 'deploydog',
    text: 'Deploydog',
    icon: 'deploydog',
  },
  {
    key: 'deskpro',
    value: 'deskpro',
    text: 'Deskpro',
    icon: 'deskpro',
  },
  {
    key: 'deviantart',
    value: 'deviantart',
    text: 'Deviantart',
    icon: 'deviantart',
  },
  {
    key: 'digg',
    value: 'digg',
    text: 'Digg',
    icon: 'digg',
  },
  {
    key: 'digital ocean',
    value: 'digital ocean',
    text: 'Digital ocean',
    icon: 'digital ocean',
  },
  {
    key: 'discord',
    value: 'discord',
    text: 'Discord',
    icon: 'discord',
  },
  {
    key: 'discourse',
    value: 'discourse',
    text: 'Discourse',
    icon: 'discourse',
  },
  {
    key: 'dochub',
    value: 'dochub',
    text: 'Dochub',
    icon: 'dochub',
  },
  {
    key: 'docker',
    value: 'docker',
    text: 'Docker',
    icon: 'docker',
  },
  {
    key: 'draft2digital',
    value: 'draft2digital',
    text: 'Draft2digital',
    icon: 'draft2digital',
  },
  {
    key: 'dribbble',
    value: 'dribbble',
    text: 'Dribbble',
    icon: 'dribbble',
  },
  {
    key: 'dribbble square',
    value: 'dribbble square',
    text: 'Dribbble square',
    icon: 'dribbble square',
  },
  {
    key: 'dropbox',
    value: 'dropbox',
    text: 'Dropbox',
    icon: 'dropbox',
  },
  {
    key: 'drupal',
    value: 'drupal',
    text: 'Drupal',
    icon: 'drupal',
  },
  {
    key: 'dyalog',
    value: 'dyalog',
    text: 'Dyalog',
    icon: 'dyalog',
  },
  {
    key: 'earlybirds',
    value: 'earlybirds',
    text: 'Earlybirds',
    icon: 'earlybirds',
  },
  {
    key: 'edge',
    value: 'edge',
    text: 'Edge',
    icon: 'edge',
  },
  {
    key: 'elementor',
    value: 'elementor',
    text: 'Elementor',
    icon: 'elementor',
  },
  {
    key: 'ember',
    value: 'ember',
    text: 'Ember',
    icon: 'ember',
  },
  {
    key: 'empire',
    value: 'empire',
    text: 'Empire',
    icon: 'empire',
  },
  {
    key: 'envira',
    value: 'envira',
    text: 'Envira',
    icon: 'envira',
  },
  {
    key: 'erlang',
    value: 'erlang',
    text: 'Erlang',
    icon: 'erlang',
  },
  {
    key: 'ethereum',
    value: 'ethereum',
    text: 'Ethereum',
    icon: 'ethereum',
  },
  {
    key: 'etsy',
    value: 'etsy',
    text: 'Etsy',
    icon: 'etsy',
  },
  {
    key: 'expeditedssl',
    value: 'expeditedssl',
    text: 'Expeditedssl',
    icon: 'expeditedssl',
  },
  {
    key: 'facebook',
    value: 'facebook',
    text: 'Facebook',
    icon: 'facebook',
  },
  {
    key: 'facebook f',
    value: 'facebook f',
    text: 'Facebook f',
    icon: 'facebook f',
  },
  {
    key: 'facebook messenger',
    value: 'facebook messenger',
    text: 'Facebook messenger',
    icon: 'facebook messenger',
  },
  {
    key: 'facebook square',
    value: 'facebook square',
    text: 'Facebook square',
    icon: 'facebook square',
  },
  {
    key: 'firefox',
    value: 'firefox',
    text: 'Firefox',
    icon: 'firefox',
  },
  {
    key: 'first order',
    value: 'first order',
    text: 'First order',
    icon: 'first order',
  },
  {
    key: 'firstdraft',
    value: 'firstdraft',
    text: 'Firstdraft',
    icon: 'firstdraft',
  },
  {
    key: 'flickr',
    value: 'flickr',
    text: 'Flickr',
    icon: 'flickr',
  },
  {
    key: 'flipboard',
    value: 'flipboard',
    text: 'Flipboard',
    icon: 'flipboard',
  },
  {
    key: 'fly',
    value: 'fly',
    text: 'Fly',
    icon: 'fly',
  },
  {
    key: 'font awesome',
    value: 'font awesome',
    text: 'Font awesome',
    icon: 'font awesome',
  },
  {
    key: 'font awesome alternate',
    value: 'font awesome alternate',
    text: 'Font awesome alternate',
    icon: 'font awesome alternate',
  },
  {
    key: 'font awesome flag',
    value: 'font awesome flag',
    text: 'Font awesome flag',
    icon: 'font awesome flag',
  },
  {
    key: 'fonticons',
    value: 'fonticons',
    text: 'Fonticons',
    icon: 'fonticons',
  },
  {
    key: 'fonticons fi',
    value: 'fonticons fi',
    text: 'Fonticons fi',
    icon: 'fonticons fi',
  },
  {
    key: 'fort awesome',
    value: 'fort awesome',
    text: 'Fort awesome',
    icon: 'fort awesome',
  },
  {
    key: 'fort awesome alternate',
    value: 'fort awesome alternate',
    text: 'Fort awesome alternate',
    icon: 'fort awesome alternate',
  },
  {
    key: 'forumbee',
    value: 'forumbee',
    text: 'Forumbee',
    icon: 'forumbee',
  },
  {
    key: 'foursquare',
    value: 'foursquare',
    text: 'Foursquare',
    icon: 'foursquare',
  },
  {
    key: 'free code camp',
    value: 'free code camp',
    text: 'Free code camp',
    icon: 'free code camp',
  },
  {
    key: 'freebsd',
    value: 'freebsd',
    text: 'Freebsd',
    icon: 'freebsd',
  },
  {
    key: 'get pocket',
    value: 'get pocket',
    text: 'Get pocket',
    icon: 'get pocket',
  },
  {
    key: 'gg',
    value: 'gg',
    text: 'Gg',
    icon: 'gg',
  },
  {
    key: 'gg circle',
    value: 'gg circle',
    text: 'Gg circle',
    icon: 'gg circle',
  },
  {
    key: 'git',
    value: 'git',
    text: 'Git',
    icon: 'git',
  },
  {
    key: 'git square',
    value: 'git square',
    text: 'Git square',
    icon: 'git square',
  },
  {
    key: 'github',
    value: 'github',
    text: 'Github',
    icon: 'github',
  },
  {
    key: 'github alternate',
    value: 'github alternate',
    text: 'Github alternate',
    icon: 'github alternate',
  },
  {
    key: 'github square',
    value: 'github square',
    text: 'Github square',
    icon: 'github square',
  },
  {
    key: 'gitkraken',
    value: 'gitkraken',
    text: 'Gitkraken',
    icon: 'gitkraken',
  },
  {
    key: 'gitlab',
    value: 'gitlab',
    text: 'Gitlab',
    icon: 'gitlab',
  },
  {
    key: 'gitter',
    value: 'gitter',
    text: 'Gitter',
    icon: 'gitter',
  },
  {
    key: 'glide',
    value: 'glide',
    text: 'Glide',
    icon: 'glide',
  },
  {
    key: 'glide g',
    value: 'glide g',
    text: 'Glide g',
    icon: 'glide g',
  },
  {
    key: 'gofore',
    value: 'gofore',
    text: 'Gofore',
    icon: 'gofore',
  },
  {
    key: 'goodreads',
    value: 'goodreads',
    text: 'Goodreads',
    icon: 'goodreads',
  },
  {
    key: 'goodreads g',
    value: 'goodreads g',
    text: 'Goodreads g',
    icon: 'goodreads g',
  },
  {
    key: 'google',
    value: 'google',
    text: 'Google',
    icon: 'google',
  },
  {
    key: 'google drive',
    value: 'google drive',
    text: 'Google drive',
    icon: 'google drive',
  },
  {
    key: 'google play',
    value: 'google play',
    text: 'Google play',
    icon: 'google play',
  },
  {
    key: 'google plus',
    value: 'google plus',
    text: 'Google plus',
    icon: 'google plus',
  },
  {
    key: 'google plus g',
    value: 'google plus g',
    text: 'Google plus g',
    icon: 'google plus g',
  },
  {
    key: 'google plus square',
    value: 'google plus square',
    text: 'Google plus square',
    icon: 'google plus square',
  },
  {
    key: 'google wallet',
    value: 'google wallet',
    text: 'Google wallet',
    icon: 'google wallet',
  },
  {
    key: 'gratipay',
    value: 'gratipay',
    text: 'Gratipay',
    icon: 'gratipay',
  },
  {
    key: 'grav',
    value: 'grav',
    text: 'Grav',
    icon: 'grav',
  },
  {
    key: 'gripfire',
    value: 'gripfire',
    text: 'Gripfire',
    icon: 'gripfire',
  },
  {
    key: 'grunt',
    value: 'grunt',
    text: 'Grunt',
    icon: 'grunt',
  },
  {
    key: 'gulp',
    value: 'gulp',
    text: 'Gulp',
    icon: 'gulp',
  },
  {
    key: 'hacker news',
    value: 'hacker news',
    text: 'Hacker news',
    icon: 'hacker news',
  },
  {
    key: 'hacker news square',
    value: 'hacker news square',
    text: 'Hacker news square',
    icon: 'hacker news square',
  },
  {
    key: 'hips',
    value: 'hips',
    text: 'Hips',
    icon: 'hips',
  },
  {
    key: 'hire a helper',
    value: 'hire a helper',
    text: 'Hire a helper',
    icon: 'hire a helper',
  },
  {
    key: 'hooli',
    value: 'hooli',
    text: 'Hooli',
    icon: 'hooli',
  },
  {
    key: 'hotjar',
    value: 'hotjar',
    text: 'Hotjar',
    icon: 'hotjar',
  },
  {
    key: 'houzz',
    value: 'houzz',
    text: 'Houzz',
    icon: 'houzz',
  },
  {
    key: 'html5',
    value: 'html5',
    text: 'Html5',
    icon: 'html5',
  },
  {
    key: 'hubspot',
    value: 'hubspot',
    text: 'Hubspot',
    icon: 'hubspot',
  },
  {
    key: 'imdb',
    value: 'imdb',
    text: 'Imdb',
    icon: 'imdb',
  },
  {
    key: 'instagram',
    value: 'instagram',
    text: 'Instagram',
    icon: 'instagram',
  },
  {
    key: 'internet explorer',
    value: 'internet explorer',
    text: 'Internet explorer',
    icon: 'internet explorer',
  },
  {
    key: 'ioxhost',
    value: 'ioxhost',
    text: 'Ioxhost',
    icon: 'ioxhost',
  },
  {
    key: 'itunes',
    value: 'itunes',
    text: 'Itunes',
    icon: 'itunes',
  },
  {
    key: 'itunes note',
    value: 'itunes note',
    text: 'Itunes note',
    icon: 'itunes note',
  },
  {
    key: 'jenkins',
    value: 'jenkins',
    text: 'Jenkins',
    icon: 'jenkins',
  },
  {
    key: 'joget',
    value: 'joget',
    text: 'Joget',
    icon: 'joget',
  },
  {
    key: 'joomla',
    value: 'joomla',
    text: 'Joomla',
    icon: 'joomla',
  },
  {
    key: 'js',
    value: 'js',
    text: 'Js',
    icon: 'js',
  },
  {
    key: 'js square',
    value: 'js square',
    text: 'Js square',
    icon: 'js square',
  },
  {
    key: 'jsfiddle',
    value: 'jsfiddle',
    text: 'Jsfiddle',
    icon: 'jsfiddle',
  },
  {
    key: 'keycdn',
    value: 'keycdn',
    text: 'Keycdn',
    icon: 'keycdn',
  },
  {
    key: 'kickstarter',
    value: 'kickstarter',
    text: 'Kickstarter',
    icon: 'kickstarter',
  },
  {
    key: 'kickstarter k',
    value: 'kickstarter k',
    text: 'Kickstarter k',
    icon: 'kickstarter k',
  },
  {
    key: 'korvue',
    value: 'korvue',
    text: 'Korvue',
    icon: 'korvue',
  },
  {
    key: 'laravel',
    value: 'laravel',
    text: 'Laravel',
    icon: 'laravel',
  },
  {
    key: 'lastfm',
    value: 'lastfm',
    text: 'Lastfm',
    icon: 'lastfm',
  },
  {
    key: 'lastfm square',
    value: 'lastfm square',
    text: 'Lastfm square',
    icon: 'lastfm square',
  },
  {
    key: 'leanpub',
    value: 'leanpub',
    text: 'Leanpub',
    icon: 'leanpub',
  },
  {
    key: 'less',
    value: 'less',
    text: 'Less',
    icon: 'less',
  },
  {
    key: 'linechat',
    value: 'linechat',
    text: 'Linechat',
    icon: 'linechat',
  },
  {
    key: 'linkedin',
    value: 'linkedin',
    text: 'Linkedin',
    icon: 'linkedin',
  },
  {
    key: 'linkedin alternate',
    value: 'linkedin alternate',
    text: 'Linkedin alternate',
    icon: 'linkedin alternate',
  },
  {
    key: 'linode',
    value: 'linode',
    text: 'Linode',
    icon: 'linode',
  },
  {
    key: 'linux',
    value: 'linux',
    text: 'Linux',
    icon: 'linux',
  },
  {
    key: 'lyft',
    value: 'lyft',
    text: 'Lyft',
    icon: 'lyft',
  },
  {
    key: 'magento',
    value: 'magento',
    text: 'Magento',
    icon: 'magento',
  },
  {
    key: 'maxcdn',
    value: 'maxcdn',
    text: 'Maxcdn',
    icon: 'maxcdn',
  },
  {
    key: 'medapps',
    value: 'medapps',
    text: 'Medapps',
    icon: 'medapps',
  },
  {
    key: 'medium',
    value: 'medium',
    text: 'Medium',
    icon: 'medium',
  },
  {
    key: 'medium m',
    value: 'medium m',
    text: 'Medium m',
    icon: 'medium m',
  },
  {
    key: 'medrt',
    value: 'medrt',
    text: 'Medrt',
    icon: 'medrt',
  },
  {
    key: 'meetup',
    value: 'meetup',
    text: 'Meetup',
    icon: 'meetup',
  },
  {
    key: 'microsoft',
    value: 'microsoft',
    text: 'Microsoft',
    icon: 'microsoft',
  },
  {
    key: 'mix',
    value: 'mix',
    text: 'Mix',
    icon: 'mix',
  },
  {
    key: 'mixcloud',
    value: 'mixcloud',
    text: 'Mixcloud',
    icon: 'mixcloud',
  },
  {
    key: 'mizuni',
    value: 'mizuni',
    text: 'Mizuni',
    icon: 'mizuni',
  },
  {
    key: 'modx',
    value: 'modx',
    text: 'Modx',
    icon: 'modx',
  },
  {
    key: 'monero',
    value: 'monero',
    text: 'Monero',
    icon: 'monero',
  },
  {
    key: 'napster',
    value: 'napster',
    text: 'Napster',
    icon: 'napster',
  },
  {
    key: 'nintendo switch',
    value: 'nintendo switch',
    text: 'Nintendo switch',
    icon: 'nintendo switch',
  },
  {
    key: 'node',
    value: 'node',
    text: 'Node',
    icon: 'node',
  },
  {
    key: 'node js',
    value: 'node js',
    text: 'Node js',
    icon: 'node js',
  },
  {
    key: 'npm',
    value: 'npm',
    text: 'Npm',
    icon: 'npm',
  },
  {
    key: 'ns8',
    value: 'ns8',
    text: 'Ns8',
    icon: 'ns8',
  },
  {
    key: 'nutritionix',
    value: 'nutritionix',
    text: 'Nutritionix',
    icon: 'nutritionix',
  },
  {
    key: 'odnoklassniki',
    value: 'odnoklassniki',
    text: 'Odnoklassniki',
    icon: 'odnoklassniki',
  },
  {
    key: 'odnoklassniki square',
    value: 'odnoklassniki square',
    text: 'Odnoklassniki square',
    icon: 'odnoklassniki square',
  },
  {
    key: 'opencart',
    value: 'opencart',
    text: 'Opencart',
    icon: 'opencart',
  },
  {
    key: 'openid',
    value: 'openid',
    text: 'Openid',
    icon: 'openid',
  },
  {
    key: 'opera',
    value: 'opera',
    text: 'Opera',
    icon: 'opera',
  },
  {
    key: 'optin monster',
    value: 'optin monster',
    text: 'Optin monster',
    icon: 'optin monster',
  },
  {
    key: 'osi',
    value: 'osi',
    text: 'Osi',
    icon: 'osi',
  },
  {
    key: 'page4',
    value: 'page4',
    text: 'Page4',
    icon: 'page4',
  },
  {
    key: 'pagelines',
    value: 'pagelines',
    text: 'Pagelines',
    icon: 'pagelines',
  },
  {
    key: 'palfed',
    value: 'palfed',
    text: 'Palfed',
    icon: 'palfed',
  },
  {
    key: 'patreon',
    value: 'patreon',
    text: 'Patreon',
    icon: 'patreon',
  },
  {
    key: 'paypal',
    value: 'paypal',
    text: 'Paypal',
    icon: 'paypal',
  },
  {
    key: 'periscope',
    value: 'periscope',
    text: 'Periscope',
    icon: 'periscope',
  },
  {
    key: 'phabricator',
    value: 'phabricator',
    text: 'Phabricator',
    icon: 'phabricator',
  },
  {
    key: 'phoenix framework',
    value: 'phoenix framework',
    text: 'Phoenix framework',
    icon: 'phoenix framework',
  },
  {
    key: 'php',
    value: 'php',
    text: 'Php',
    icon: 'php',
  },
  {
    key: 'pied piper',
    value: 'pied piper',
    text: 'Pied piper',
    icon: 'pied piper',
  },
  {
    key: 'pied piper alternate',
    value: 'pied piper alternate',
    text: 'Pied piper alternate',
    icon: 'pied piper alternate',
  },
  {
    key: 'pied piper pp',
    value: 'pied piper pp',
    text: 'Pied piper pp',
    icon: 'pied piper pp',
  },
  {
    key: 'pinterest',
    value: 'pinterest',
    text: 'Pinterest',
    icon: 'pinterest',
  },
  {
    key: 'pinterest p',
    value: 'pinterest p',
    text: 'Pinterest p',
    icon: 'pinterest p',
  },
  {
    key: 'pinterest square',
    value: 'pinterest square',
    text: 'Pinterest square',
    icon: 'pinterest square',
  },
  {
    key: 'playstation',
    value: 'playstation',
    text: 'Playstation',
    icon: 'playstation',
  },
  {
    key: 'product hunt',
    value: 'product hunt',
    text: 'Product hunt',
    icon: 'product hunt',
  },
  {
    key: 'pushed',
    value: 'pushed',
    text: 'Pushed',
    icon: 'pushed',
  },
  {
    key: 'python',
    value: 'python',
    text: 'Python',
    icon: 'python',
  },
  {
    key: 'qq',
    value: 'qq',
    text: 'Qq',
    icon: 'qq',
  },
  {
    key: 'quinscape',
    value: 'quinscape',
    text: 'Quinscape',
    icon: 'quinscape',
  },
  {
    key: 'quora',
    value: 'quora',
    text: 'Quora',
    icon: 'quora',
  },
  {
    key: 'ravelry',
    value: 'ravelry',
    text: 'Ravelry',
    icon: 'ravelry',
  },
  {
    key: 'react',
    value: 'react',
    text: 'React',
    icon: 'react',
  },
  {
    key: 'rebel',
    value: 'rebel',
    text: 'Rebel',
    icon: 'rebel',
  },
  {
    key: 'redriver',
    value: 'redriver',
    text: 'Redriver',
    icon: 'redriver',
  },
  {
    key: 'reddit',
    value: 'reddit',
    text: 'Reddit',
    icon: 'reddit',
  },
  {
    key: 'reddit alien',
    value: 'reddit alien',
    text: 'Reddit alien',
    icon: 'reddit alien',
  },
  {
    key: 'reddit square',
    value: 'reddit square',
    text: 'Reddit square',
    icon: 'reddit square',
  },
  {
    key: 'rendact',
    value: 'rendact',
    text: 'Rendact',
    icon: 'rendact',
  },
  {
    key: 'renren',
    value: 'renren',
    text: 'Renren',
    icon: 'renren',
  },
  {
    key: 'replyd',
    value: 'replyd',
    text: 'Replyd',
    icon: 'replyd',
  },
  {
    key: 'resolving',
    value: 'resolving',
    text: 'Resolving',
    icon: 'resolving',
  },
  {
    key: 'rocketchat',
    value: 'rocketchat',
    text: 'Rocketchat',
    icon: 'rocketchat',
  },
  {
    key: 'rockrms',
    value: 'rockrms',
    text: 'Rockrms',
    icon: 'rockrms',
  },
  {
    key: 'safari',
    value: 'safari',
    text: 'Safari',
    icon: 'safari',
  },
  {
    key: 'sass',
    value: 'sass',
    text: 'Sass',
    icon: 'sass',
  },
  {
    key: 'schlix',
    value: 'schlix',
    text: 'Schlix',
    icon: 'schlix',
  },
  {
    key: 'scribd',
    value: 'scribd',
    text: 'Scribd',
    icon: 'scribd',
  },
  {
    key: 'searchengin',
    value: 'searchengin',
    text: 'Searchengin',
    icon: 'searchengin',
  },
  {
    key: 'sellcast',
    value: 'sellcast',
    text: 'Sellcast',
    icon: 'sellcast',
  },
  {
    key: 'sellsy',
    value: 'sellsy',
    text: 'Sellsy',
    icon: 'sellsy',
  },
  {
    key: 'servicestack',
    value: 'servicestack',
    text: 'Servicestack',
    icon: 'servicestack',
  },
  {
    key: 'shirtsinbulk',
    value: 'shirtsinbulk',
    text: 'Shirtsinbulk',
    icon: 'shirtsinbulk',
  },
  {
    key: 'simplybuilt',
    value: 'simplybuilt',
    text: 'Simplybuilt',
    icon: 'simplybuilt',
  },
  {
    key: 'sistrix',
    value: 'sistrix',
    text: 'Sistrix',
    icon: 'sistrix',
  },
  {
    key: 'skyatlas',
    value: 'skyatlas',
    text: 'Skyatlas',
    icon: 'skyatlas',
  },
  {
    key: 'skype',
    value: 'skype',
    text: 'Skype',
    icon: 'skype',
  },
  {
    key: 'slack',
    value: 'slack',
    text: 'Slack',
    icon: 'slack',
  },
  {
    key: 'slack hash',
    value: 'slack hash',
    text: 'Slack hash',
    icon: 'slack hash',
  },
  {
    key: 'slideshare',
    value: 'slideshare',
    text: 'Slideshare',
    icon: 'slideshare',
  },
  {
    key: 'snapchat',
    value: 'snapchat',
    text: 'Snapchat',
    icon: 'snapchat',
  },
  {
    key: 'snapchat ghost',
    value: 'snapchat ghost',
    text: 'Snapchat ghost',
    icon: 'snapchat ghost',
  },
  {
    key: 'snapchat square',
    value: 'snapchat square',
    text: 'Snapchat square',
    icon: 'snapchat square',
  },
  {
    key: 'soundcloud',
    value: 'soundcloud',
    text: 'Soundcloud',
    icon: 'soundcloud',
  },
  {
    key: 'speakap',
    value: 'speakap',
    text: 'Speakap',
    icon: 'speakap',
  },
  {
    key: 'spotify',
    value: 'spotify',
    text: 'Spotify',
    icon: 'spotify',
  },
  {
    key: 'stack exchange',
    value: 'stack exchange',
    text: 'Stack exchange',
    icon: 'stack exchange',
  },
  {
    key: 'stack overflow',
    value: 'stack overflow',
    text: 'Stack overflow',
    icon: 'stack overflow',
  },
  {
    key: 'staylinked',
    value: 'staylinked',
    text: 'Staylinked',
    icon: 'staylinked',
  },
  {
    key: 'steam',
    value: 'steam',
    text: 'Steam',
    icon: 'steam',
  },
  {
    key: 'steam square',
    value: 'steam square',
    text: 'Steam square',
    icon: 'steam square',
  },
  {
    key: 'steam symbol',
    value: 'steam symbol',
    text: 'Steam symbol',
    icon: 'steam symbol',
  },
  {
    key: 'sticker mule',
    value: 'sticker mule',
    text: 'Sticker mule',
    icon: 'sticker mule',
  },
  {
    key: 'strava',
    value: 'strava',
    text: 'Strava',
    icon: 'strava',
  },
  {
    key: 'stripe',
    value: 'stripe',
    text: 'Stripe',
    icon: 'stripe',
  },
  {
    key: 'stripe s',
    value: 'stripe s',
    text: 'Stripe s',
    icon: 'stripe s',
  },
  {
    key: 'studiovinari',
    value: 'studiovinari',
    text: 'Studiovinari',
    icon: 'studiovinari',
  },
  {
    key: 'stumbleupon',
    value: 'stumbleupon',
    text: 'Stumbleupon',
    icon: 'stumbleupon',
  },
  {
    key: 'stumbleupon circle',
    value: 'stumbleupon circle',
    text: 'Stumbleupon circle',
    icon: 'stumbleupon circle',
  },
  {
    key: 'superpowers',
    value: 'superpowers',
    text: 'Superpowers',
    icon: 'superpowers',
  },
  {
    key: 'supple',
    value: 'supple',
    text: 'Supple',
    icon: 'supple',
  },
  {
    key: 'telegram',
    value: 'telegram',
    text: 'Telegram',
    icon: 'telegram',
  },
  {
    key: 'telegram plane',
    value: 'telegram plane',
    text: 'Telegram plane',
    icon: 'telegram plane',
  },
  {
    key: 'tencent weibo',
    value: 'tencent weibo',
    text: 'Tencent weibo',
    icon: 'tencent weibo',
  },
  {
    key: 'themeisle',
    value: 'themeisle',
    text: 'Themeisle',
    icon: 'themeisle',
  },
  {
    key: 'trello',
    value: 'trello',
    text: 'Trello',
    icon: 'trello',
  },
  {
    key: 'tripadvisor',
    value: 'tripadvisor',
    text: 'Tripadvisor',
    icon: 'tripadvisor',
  },
  {
    key: 'tumblr',
    value: 'tumblr',
    text: 'Tumblr',
    icon: 'tumblr',
  },
  {
    key: 'tumblr square',
    value: 'tumblr square',
    text: 'Tumblr square',
    icon: 'tumblr square',
  },
  {
    key: 'twitch',
    value: 'twitch',
    text: 'Twitch',
    icon: 'twitch',
  },
  {
    key: 'twitter',
    value: 'twitter',
    text: 'Twitter',
    icon: 'twitter',
  },
  {
    key: 'twitter square',
    value: 'twitter square',
    text: 'Twitter square',
    icon: 'twitter square',
  },
  {
    key: 'typo3',
    value: 'typo3',
    text: 'Typo3',
    icon: 'typo3',
  },
  {
    key: 'uber',
    value: 'uber',
    text: 'Uber',
    icon: 'uber',
  },
  {
    key: 'uikit',
    value: 'uikit',
    text: 'Uikit',
    icon: 'uikit',
  },
  {
    key: 'uniregistry',
    value: 'uniregistry',
    text: 'Uniregistry',
    icon: 'uniregistry',
  },
  {
    key: 'untappd',
    value: 'untappd',
    text: 'Untappd',
    icon: 'untappd',
  },
  {
    key: 'usb',
    value: 'usb',
    text: 'Usb',
    icon: 'usb',
  },
  {
    key: 'ussunnah',
    value: 'ussunnah',
    text: 'Ussunnah',
    icon: 'ussunnah',
  },
  {
    key: 'vaadin',
    value: 'vaadin',
    text: 'Vaadin',
    icon: 'vaadin',
  },
  {
    key: 'viacoin',
    value: 'viacoin',
    text: 'Viacoin',
    icon: 'viacoin',
  },
  {
    key: 'viadeo',
    value: 'viadeo',
    text: 'Viadeo',
    icon: 'viadeo',
  },
  {
    key: 'viadeo square',
    value: 'viadeo square',
    text: 'Viadeo square',
    icon: 'viadeo square',
  },
  {
    key: 'viber',
    value: 'viber',
    text: 'Viber',
    icon: 'viber',
  },
  {
    key: 'vimeo',
    value: 'vimeo',
    text: 'Vimeo',
    icon: 'vimeo',
  },
  {
    key: 'vimeo square',
    value: 'vimeo square',
    text: 'Vimeo square',
    icon: 'vimeo square',
  },
  {
    key: 'vimeo v',
    value: 'vimeo v',
    text: 'Vimeo v',
    icon: 'vimeo v',
  },
  {
    key: 'vine',
    value: 'vine',
    text: 'Vine',
    icon: 'vine',
  },
  {
    key: 'vk',
    value: 'vk',
    text: 'Vk',
    icon: 'vk',
  },
  {
    key: 'vnv',
    value: 'vnv',
    text: 'Vnv',
    icon: 'vnv',
  },
  {
    key: 'vuejs',
    value: 'vuejs',
    text: 'Vuejs',
    icon: 'vuejs',
  },
  {
    key: 'wechat',
    value: 'wechat',
    text: 'Wechat',
    icon: 'wechat',
  },
  {
    key: 'weibo',
    value: 'weibo',
    text: 'Weibo',
    icon: 'weibo',
  },
  {
    key: 'weixin',
    value: 'weixin',
    text: 'Weixin',
    icon: 'weixin',
  },
  {
    key: 'whatsapp',
    value: 'whatsapp',
    text: 'Whatsapp',
    icon: 'whatsapp',
  },
  {
    key: 'whatsapp square',
    value: 'whatsapp square',
    text: 'Whatsapp square',
    icon: 'whatsapp square',
  },
  {
    key: 'whmcs',
    value: 'whmcs',
    text: 'Whmcs',
    icon: 'whmcs',
  },
  {
    key: 'wikipedia w',
    value: 'wikipedia w',
    text: 'Wikipedia w',
    icon: 'wikipedia w',
  },
  {
    key: 'windows',
    value: 'windows',
    text: 'Windows',
    icon: 'windows',
  },
  {
    key: 'wordpress',
    value: 'wordpress',
    text: 'Wordpress',
    icon: 'wordpress',
  },
  {
    key: 'wordpress simple',
    value: 'wordpress simple',
    text: 'Wordpress simple',
    icon: 'wordpress simple',
  },
  {
    key: 'wpbeginner',
    value: 'wpbeginner',
    text: 'Wpbeginner',
    icon: 'wpbeginner',
  },
  {
    key: 'wpexplorer',
    value: 'wpexplorer',
    text: 'Wpexplorer',
    icon: 'wpexplorer',
  },
  {
    key: 'wpforms',
    value: 'wpforms',
    text: 'Wpforms',
    icon: 'wpforms',
  },
  {
    key: 'xbox',
    value: 'xbox',
    text: 'Xbox',
    icon: 'xbox',
  },
  {
    key: 'xing',
    value: 'xing',
    text: 'Xing',
    icon: 'xing',
  },
  {
    key: 'xing square',
    value: 'xing square',
    text: 'Xing square',
    icon: 'xing square',
  },
  {
    key: 'y combinator',
    value: 'y combinator',
    text: 'Y combinator',
    icon: 'y combinator',
  },
  {
    key: 'yahoo',
    value: 'yahoo',
    text: 'Yahoo',
    icon: 'yahoo',
  },
  {
    key: 'yandex',
    value: 'yandex',
    text: 'Yandex',
    icon: 'yandex',
  },
  {
    key: 'yandex international',
    value: 'yandex international',
    text: 'Yandex international',
    icon: 'yandex international',
  },
  {
    key: 'yelp',
    value: 'yelp',
    text: 'Yelp',
    icon: 'yelp',
  },
  {
    key: 'yoast',
    value: 'yoast',
    text: 'Yoast',
    icon: 'yoast',
  },
  {
    key: 'youtube',
    value: 'youtube',
    text: 'Youtube',
    icon: 'youtube',
  },
  {
    key: 'youtube square',
    value: 'youtube square',
    text: 'Youtube square',
    icon: 'youtube square',
  },
  {
    key: 'chess rock',
    value: 'chess rock',
    text: 'Chess rock',
    icon: 'chess rock',
  },
  {
    key: 'ordered list',
    value: 'ordered list',
    text: 'Ordered list',
    icon: 'ordered list',
  },
  {
    key: 'unordered list',
    value: 'unordered list',
    text: 'Unordered list',
    icon: 'unordered list',
  },
  {
    key: 'user doctor',
    value: 'user doctor',
    text: 'User doctor',
    icon: 'user doctor',
  },
  {
    key: 'shield',
    value: 'shield',
    text: 'Shield',
    icon: 'shield',
  },
  {
    key: 'puzzle',
    value: 'puzzle',
    text: 'Puzzle',
    icon: 'puzzle',
  },
  {
    key: 'add circle',
    value: 'add circle',
    text: 'Add circle',
    icon: 'add circle',
  },
  {
    key: 'add square',
    value: 'add square',
    text: 'Add square',
    icon: 'add square',
  },
  {
    key: 'add to calendar',
    value: 'add to calendar',
    text: 'Add to calendar',
    icon: 'add to calendar',
  },
  {
    key: 'add to cart',
    value: 'add to cart',
    text: 'Add to cart',
    icon: 'add to cart',
  },
  {
    key: 'add user',
    value: 'add user',
    text: 'Add user',
    icon: 'add user',
  },
  {
    key: 'add',
    value: 'add',
    text: 'Add',
    icon: 'add',
  },
  {
    key: 'alarm mute',
    value: 'alarm mute',
    text: 'Alarm mute',
    icon: 'alarm mute',
  },
  {
    key: 'alarm',
    value: 'alarm',
    text: 'Alarm',
    icon: 'alarm',
  },
  {
    key: 'ald',
    value: 'ald',
    text: 'Ald',
    icon: 'ald',
  },
  {
    key: 'als',
    value: 'als',
    text: 'Als',
    icon: 'als',
  },
  {
    key: 'announcement',
    value: 'announcement',
    text: 'Announcement',
    icon: 'announcement',
  },
  {
    key: 'area chart',
    value: 'area chart',
    text: 'Area chart',
    icon: 'area chart',
  },
  {
    key: 'area graph',
    value: 'area graph',
    text: 'Area graph',
    icon: 'area graph',
  },
  {
    key: 'arrow down cart',
    value: 'arrow down cart',
    text: 'Arrow down cart',
    icon: 'arrow down cart',
  },
  {
    key: 'asexual',
    value: 'asexual',
    text: 'Asexual',
    icon: 'asexual',
  },
  {
    key: 'asl interpreting',
    value: 'asl interpreting',
    text: 'Asl interpreting',
    icon: 'asl interpreting',
  },
  {
    key: 'asl',
    value: 'asl',
    text: 'Asl',
    icon: 'asl',
  },
  {
    key: 'assistive listening devices',
    value: 'assistive listening devices',
    text: 'Assistive listening devices',
    icon: 'assistive listening devices',
  },
  {
    key: 'attach',
    value: 'attach',
    text: 'Attach',
    icon: 'attach',
  },
  {
    key: 'attention',
    value: 'attention',
    text: 'Attention',
    icon: 'attention',
  },
  {
    key: 'balance',
    value: 'balance',
    text: 'Balance',
    icon: 'balance',
  },
  {
    key: 'bar',
    value: 'bar',
    text: 'Bar',
    icon: 'bar',
  },
  {
    key: 'bathtub',
    value: 'bathtub',
    text: 'Bathtub',
    icon: 'bathtub',
  },
  {
    key: 'battery four',
    value: 'battery four',
    text: 'Battery four',
    icon: 'battery four',
  },
  {
    key: 'battery high',
    value: 'battery high',
    text: 'Battery high',
    icon: 'battery high',
  },
  {
    key: 'battery low',
    value: 'battery low',
    text: 'Battery low',
    icon: 'battery low',
  },
  {
    key: 'battery one',
    value: 'battery one',
    text: 'Battery one',
    icon: 'battery one',
  },
  {
    key: 'battery three',
    value: 'battery three',
    text: 'Battery three',
    icon: 'battery three',
  },
  {
    key: 'battery two',
    value: 'battery two',
    text: 'Battery two',
    icon: 'battery two',
  },
  {
    key: 'battery zero',
    value: 'battery zero',
    text: 'Battery zero',
    icon: 'battery zero',
  },
  {
    key: 'birthday',
    value: 'birthday',
    text: 'Birthday',
    icon: 'birthday',
  },
  {
    key: 'block layout',
    value: 'block layout',
    text: 'Block layout',
    icon: 'block layout',
  },
  {
    key: 'bluetooth alternative',
    value: 'bluetooth alternative',
    text: 'Bluetooth alternative',
    icon: 'bluetooth alternative',
  },
  {
    key: 'broken chain',
    value: 'broken chain',
    text: 'Broken chain',
    icon: 'broken chain',
  },
  {
    key: 'browser',
    value: 'browser',
    text: 'Browser',
    icon: 'browser',
  },
  {
    key: 'call square',
    value: 'call square',
    text: 'Call square',
    icon: 'call square',
  },
  {
    key: 'call',
    value: 'call',
    text: 'Call',
    icon: 'call',
  },
  {
    key: 'cancel',
    value: 'cancel',
    text: 'Cancel',
    icon: 'cancel',
  },
  {
    key: 'cart',
    value: 'cart',
    text: 'Cart',
    icon: 'cart',
  },
  {
    key: 'cc',
    value: 'cc',
    text: 'Cc',
    icon: 'cc',
  },
  {
    key: 'chain',
    value: 'chain',
    text: 'Chain',
    icon: 'chain',
  },
  {
    key: 'chat',
    value: 'chat',
    text: 'Chat',
    icon: 'chat',
  },
  {
    key: 'checked calendar',
    value: 'checked calendar',
    text: 'Checked calendar',
    icon: 'checked calendar',
  },
  {
    key: 'checkmark',
    value: 'checkmark',
    text: 'Checkmark',
    icon: 'checkmark',
  },
  {
    key: 'circle notched',
    value: 'circle notched',
    text: 'Circle notched',
    icon: 'circle notched',
  },
  {
    key: 'close',
    value: 'close',
    text: 'Close',
    icon: 'close',
  },
  {
    key: 'cny',
    value: 'cny',
    text: 'Cny',
    icon: 'cny',
  },
  {
    key: 'cocktail',
    value: 'cocktail',
    text: 'Cocktail',
    icon: 'cocktail',
  },
  {
    key: 'commenting',
    value: 'commenting',
    text: 'Commenting',
    icon: 'commenting',
  },
  {
    key: 'computer',
    value: 'computer',
    text: 'Computer',
    icon: 'computer',
  },
  {
    key: 'configure',
    value: 'configure',
    text: 'Configure',
    icon: 'configure',
  },
  {
    key: 'content',
    value: 'content',
    text: 'Content',
    icon: 'content',
  },
  {
    key: 'deafness',
    value: 'deafness',
    text: 'Deafness',
    icon: 'deafness',
  },
  {
    key: 'delete calendar',
    value: 'delete calendar',
    text: 'Delete calendar',
    icon: 'delete calendar',
  },
  {
    key: 'delete',
    value: 'delete',
    text: 'Delete',
    icon: 'delete',
  },
  {
    key: 'detective',
    value: 'detective',
    text: 'Detective',
    icon: 'detective',
  },
  {
    key: 'discussions',
    value: 'discussions',
    text: 'Discussions',
    icon: 'discussions',
  },
  {
    key: 'doctor',
    value: 'doctor',
    text: 'Doctor',
    icon: 'doctor',
  },
  {
    key: 'dollar',
    value: 'dollar',
    text: 'Dollar',
    icon: 'dollar',
  },
  {
    key: 'dont',
    value: 'dont',
    text: 'Dont',
    icon: 'dont',
  },
  {
    key: 'drivers license',
    value: 'drivers license',
    text: 'Drivers license',
    icon: 'drivers license',
  },
  {
    key: 'dropdown',
    value: 'dropdown',
    text: 'Dropdown',
    icon: 'dropdown',
  },
  {
    key: 'emergency',
    value: 'emergency',
    text: 'Emergency',
    icon: 'emergency',
  },
  {
    key: 'envira gallery',
    value: 'envira gallery',
    text: 'Envira gallery',
    icon: 'envira gallery',
  },
  {
    key: 'erase',
    value: 'erase',
    text: 'Erase',
    icon: 'erase',
  },
  {
    key: 'eur',
    value: 'eur',
    text: 'Eur',
    icon: 'eur',
  },
  {
    key: 'euro',
    value: 'euro',
    text: 'Euro',
    icon: 'euro',
  },
  {
    key: 'eyedropper',
    value: 'eyedropper',
    text: 'Eyedropper',
    icon: 'eyedropper',
  },
  {
    key: 'factory',
    value: 'factory',
    text: 'Factory',
    icon: 'factory',
  },
  {
    key: 'favorite',
    value: 'favorite',
    text: 'Favorite',
    icon: 'favorite',
  },
  {
    key: 'feed',
    value: 'feed',
    text: 'Feed',
    icon: 'feed',
  },
  {
    key: 'female homosexual',
    value: 'female homosexual',
    text: 'Female homosexual',
    icon: 'female homosexual',
  },
  {
    key: 'file text',
    value: 'file text',
    text: 'File text',
    icon: 'file text',
  },
  {
    key: 'file text outline',
    value: 'file text outline',
    text: 'File text outline',
    icon: 'file text outline',
  },
  {
    key: 'find',
    value: 'find',
    text: 'Find',
    icon: 'find',
  },
  {
    key: 'fork',
    value: 'fork',
    text: 'Fork',
    icon: 'fork',
  },
  {
    key: 'game',
    value: 'game',
    text: 'Game',
    icon: 'game',
  },
  {
    key: 'gay',
    value: 'gay',
    text: 'Gay',
    icon: 'gay',
  },
  {
    key: 'gbp',
    value: 'gbp',
    text: 'Gbp',
    icon: 'gbp',
  },
  {
    key: 'google plus circle',
    value: 'google plus circle',
    text: 'Google plus circle',
    icon: 'google plus circle',
  },
  {
    key: 'google plus official',
    value: 'google plus official',
    text: 'Google plus official',
    icon: 'google plus official',
  },
  {
    key: 'grab',
    value: 'grab',
    text: 'Grab',
    icon: 'grab',
  },
  {
    key: 'graduation',
    value: 'graduation',
    text: 'Graduation',
    icon: 'graduation',
  },
  {
    key: 'grid layout',
    value: 'grid layout',
    text: 'Grid layout',
    icon: 'grid layout',
  },
  {
    key: 'group',
    value: 'group',
    text: 'Group',
    icon: 'group',
  },
  {
    key: 'h',
    value: 'h',
    text: 'H',
    icon: 'h',
  },
  {
    key: 'hand victory',
    value: 'hand victory',
    text: 'Hand victory',
    icon: 'hand victory',
  },
  {
    key: 'handicap',
    value: 'handicap',
    text: 'Handicap',
    icon: 'handicap',
  },
  {
    key: 'hard of hearing',
    value: 'hard of hearing',
    text: 'Hard of hearing',
    icon: 'hard of hearing',
  },
  {
    key: 'header',
    value: 'header',
    text: 'Header',
    icon: 'header',
  },
  {
    key: 'help circle',
    value: 'help circle',
    text: 'Help circle',
    icon: 'help circle',
  },
  {
    key: 'help',
    value: 'help',
    text: 'Help',
    icon: 'help',
  },
  {
    key: 'heterosexual',
    value: 'heterosexual',
    text: 'Heterosexual',
    icon: 'heterosexual',
  },
  {
    key: 'hide',
    value: 'hide',
    text: 'Hide',
    icon: 'hide',
  },
  {
    key: 'hotel',
    value: 'hotel',
    text: 'Hotel',
    icon: 'hotel',
  },
  {
    key: 'hourglass four',
    value: 'hourglass four',
    text: 'Hourglass four',
    icon: 'hourglass four',
  },
  {
    key: 'hourglass full',
    value: 'hourglass full',
    text: 'Hourglass full',
    icon: 'hourglass full',
  },
  {
    key: 'hourglass one',
    value: 'hourglass one',
    text: 'Hourglass one',
    icon: 'hourglass one',
  },
  {
    key: 'hourglass three',
    value: 'hourglass three',
    text: 'Hourglass three',
    icon: 'hourglass three',
  },
  {
    key: 'hourglass two',
    value: 'hourglass two',
    text: 'Hourglass two',
    icon: 'hourglass two',
  },
  {
    key: 'idea',
    value: 'idea',
    text: 'Idea',
    icon: 'idea',
  },
  {
    key: 'ils',
    value: 'ils',
    text: 'Ils',
    icon: 'ils',
  },
  {
    key: 'in cart',
    value: 'in cart',
    text: 'In cart',
    icon: 'in cart',
  },
  {
    key: 'inr',
    value: 'inr',
    text: 'Inr',
    icon: 'inr',
  },
  {
    key: 'intergender',
    value: 'intergender',
    text: 'Intergender',
    icon: 'intergender',
  },
  {
    key: 'intersex',
    value: 'intersex',
    text: 'Intersex',
    icon: 'intersex',
  },
  {
    key: 'jpy',
    value: 'jpy',
    text: 'Jpy',
    icon: 'jpy',
  },
  {
    key: 'krw',
    value: 'krw',
    text: 'Krw',
    icon: 'krw',
  },
  {
    key: 'lab',
    value: 'lab',
    text: 'Lab',
    icon: 'lab',
  },
  {
    key: 'law',
    value: 'law',
    text: 'Law',
    icon: 'law',
  },
  {
    key: 'legal',
    value: 'legal',
    text: 'Legal',
    icon: 'legal',
  },
  {
    key: 'lesbian',
    value: 'lesbian',
    text: 'Lesbian',
    icon: 'lesbian',
  },
  {
    key: 'lightning',
    value: 'lightning',
    text: 'Lightning',
    icon: 'lightning',
  },
  {
    key: 'like',
    value: 'like',
    text: 'Like',
    icon: 'like',
  },
  {
    key: 'line graph',
    value: 'line graph',
    text: 'Line graph',
    icon: 'line graph',
  },
  {
    key: 'linkedin square',
    value: 'linkedin square',
    text: 'Linkedin square',
    icon: 'linkedin square',
  },
  {
    key: 'lira',
    value: 'lira',
    text: 'Lira',
    icon: 'lira',
  },
  {
    key: 'list layout',
    value: 'list layout',
    text: 'List layout',
    icon: 'list layout',
  },
  {
    key: 'magnify',
    value: 'magnify',
    text: 'Magnify',
    icon: 'magnify',
  },
  {
    key: 'mail forward',
    value: 'mail forward',
    text: 'Mail forward',
    icon: 'mail forward',
  },
  {
    key: 'mail outline',
    value: 'mail outline',
    text: 'Mail outline',
    icon: 'mail outline',
  },
  {
    key: 'mail square',
    value: 'mail square',
    text: 'Mail square',
    icon: 'mail square',
  },
  {
    key: 'mail',
    value: 'mail',
    text: 'Mail',
    icon: 'mail',
  },
  {
    key: 'male homosexual',
    value: 'male homosexual',
    text: 'Male homosexual',
    icon: 'male homosexual',
  },
  {
    key: 'man',
    value: 'man',
    text: 'Man',
    icon: 'man',
  },
  {
    key: 'marker',
    value: 'marker',
    text: 'Marker',
    icon: 'marker',
  },
  {
    key: 'mars alternate',
    value: 'mars alternate',
    text: 'Mars alternate',
    icon: 'mars alternate',
  },
  {
    key: 'mars horizontal',
    value: 'mars horizontal',
    text: 'Mars horizontal',
    icon: 'mars horizontal',
  },
  {
    key: 'mars vertical',
    value: 'mars vertical',
    text: 'Mars vertical',
    icon: 'mars vertical',
  },
  {
    key: 'microsoft edge',
    value: 'microsoft edge',
    text: 'Microsoft edge',
    icon: 'microsoft edge',
  },
  {
    key: 'military',
    value: 'military',
    text: 'Military',
    icon: 'military',
  },
  {
    key: 'ms edge',
    value: 'ms edge',
    text: 'Ms edge',
    icon: 'ms edge',
  },
  {
    key: 'mute',
    value: 'mute',
    text: 'Mute',
    icon: 'mute',
  },
  {
    key: 'new pied piper',
    value: 'new pied piper',
    text: 'New pied piper',
    icon: 'new pied piper',
  },
  {
    key: 'non binary transgender',
    value: 'non binary transgender',
    text: 'Non binary transgender',
    icon: 'non binary transgender',
  },
  {
    key: 'numbered list',
    value: 'numbered list',
    text: 'Numbered list',
    icon: 'numbered list',
  },
  {
    key: 'options',
    value: 'options',
    text: 'Options',
    icon: 'options',
  },
  {
    key: 'other gender horizontal',
    value: 'other gender horizontal',
    text: 'Other gender horizontal',
    icon: 'other gender horizontal',
  },
  {
    key: 'other gender vertical',
    value: 'other gender vertical',
    text: 'Other gender vertical',
    icon: 'other gender vertical',
  },
  {
    key: 'other gender',
    value: 'other gender',
    text: 'Other gender',
    icon: 'other gender',
  },
  {
    key: 'payment',
    value: 'payment',
    text: 'Payment',
    icon: 'payment',
  },
  {
    key: 'paypal card',
    value: 'paypal card',
    text: 'Paypal card',
    icon: 'paypal card',
  },
  {
    key: 'pencil square',
    value: 'pencil square',
    text: 'Pencil square',
    icon: 'pencil square',
  },
  {
    key: 'photo',
    value: 'photo',
    text: 'Photo',
    icon: 'photo',
  },
  {
    key: 'picture',
    value: 'picture',
    text: 'Picture',
    icon: 'picture',
  },
  {
    key: 'pie chart',
    value: 'pie chart',
    text: 'Pie chart',
    icon: 'pie chart',
  },
  {
    key: 'pie graph',
    value: 'pie graph',
    text: 'Pie graph',
    icon: 'pie graph',
  },
  {
    key: 'pied piper hat',
    value: 'pied piper hat',
    text: 'Pied piper hat',
    icon: 'pied piper hat',
  },
  {
    key: 'pin',
    value: 'pin',
    text: 'Pin',
    icon: 'pin',
  },
  {
    key: 'plus cart',
    value: 'plus cart',
    text: 'Plus cart',
    icon: 'plus cart',
  },
  {
    key: 'point',
    value: 'point',
    text: 'Point',
    icon: 'point',
  },
  {
    key: 'pointing down',
    value: 'pointing down',
    text: 'Pointing down',
    icon: 'pointing down',
  },
  {
    key: 'pointing left',
    value: 'pointing left',
    text: 'Pointing left',
    icon: 'pointing left',
  },
  {
    key: 'pointing right',
    value: 'pointing right',
    text: 'Pointing right',
    icon: 'pointing right',
  },
  {
    key: 'pointing up',
    value: 'pointing up',
    text: 'Pointing up',
    icon: 'pointing up',
  },
  {
    key: 'pound',
    value: 'pound',
    text: 'Pound',
    icon: 'pound',
  },
  {
    key: 'power cord',
    value: 'power cord',
    text: 'Power cord',
    icon: 'power cord',
  },
  {
    key: 'power',
    value: 'power',
    text: 'Power',
    icon: 'power',
  },
  {
    key: 'privacy',
    value: 'privacy',
    text: 'Privacy',
    icon: 'privacy',
  },
  {
    key: 'r circle',
    value: 'r circle',
    text: 'R circle',
    icon: 'r circle',
  },
  {
    key: 'rain',
    value: 'rain',
    text: 'Rain',
    icon: 'rain',
  },
  {
    key: 'record',
    value: 'record',
    text: 'Record',
    icon: 'record',
  },
  {
    key: 'refresh',
    value: 'refresh',
    text: 'Refresh',
    icon: 'refresh',
  },
  {
    key: 'remove circle',
    value: 'remove circle',
    text: 'Remove circle',
    icon: 'remove circle',
  },
  {
    key: 'remove from calendar',
    value: 'remove from calendar',
    text: 'Remove from calendar',
    icon: 'remove from calendar',
  },
  {
    key: 'remove user',
    value: 'remove user',
    text: 'Remove user',
    icon: 'remove user',
  },
  {
    key: 'remove',
    value: 'remove',
    text: 'Remove',
    icon: 'remove',
  },
  {
    key: 'repeat',
    value: 'repeat',
    text: 'Repeat',
    icon: 'repeat',
  },
  {
    key: 'rmb',
    value: 'rmb',
    text: 'Rmb',
    icon: 'rmb',
  },
  {
    key: 'rouble',
    value: 'rouble',
    text: 'Rouble',
    icon: 'rouble',
  },
  {
    key: 'rub',
    value: 'rub',
    text: 'Rub',
    icon: 'rub',
  },
  {
    key: 'ruble',
    value: 'ruble',
    text: 'Ruble',
    icon: 'ruble',
  },
  {
    key: 'rupee',
    value: 'rupee',
    text: 'Rupee',
    icon: 'rupee',
  },
  {
    key: 's15',
    value: 's15',
    text: 'S15',
    icon: 's15',
  },
  {
    key: 'selected radio',
    value: 'selected radio',
    text: 'Selected radio',
    icon: 'selected radio',
  },
  {
    key: 'send',
    value: 'send',
    text: 'Send',
    icon: 'send',
  },
  {
    key: 'setting',
    value: 'setting',
    text: 'Setting',
    icon: 'setting',
  },
  {
    key: 'settings',
    value: 'settings',
    text: 'Settings',
    icon: 'settings',
  },
  {
    key: 'shekel',
    value: 'shekel',
    text: 'Shekel',
    icon: 'shekel',
  },
  {
    key: 'sheqel',
    value: 'sheqel',
    text: 'Sheqel',
    icon: 'sheqel',
  },
  {
    key: 'shipping',
    value: 'shipping',
    text: 'Shipping',
    icon: 'shipping',
  },
  {
    key: 'shop',
    value: 'shop',
    text: 'Shop',
    icon: 'shop',
  },
  {
    key: 'shuffle',
    value: 'shuffle',
    text: 'Shuffle',
    icon: 'shuffle',
  },
  {
    key: 'shutdown',
    value: 'shutdown',
    text: 'Shutdown',
    icon: 'shutdown',
  },
  {
    key: 'sidebar',
    value: 'sidebar',
    text: 'Sidebar',
    icon: 'sidebar',
  },
  {
    key: 'signing',
    value: 'signing',
    text: 'Signing',
    icon: 'signing',
  },
  {
    key: 'signup',
    value: 'signup',
    text: 'Signup',
    icon: 'signup',
  },
  {
    key: 'sliders',
    value: 'sliders',
    text: 'Sliders',
    icon: 'sliders',
  },
  {
    key: 'soccer',
    value: 'soccer',
    text: 'Soccer',
    icon: 'soccer',
  },
  {
    key: 'sort alphabet ascending',
    value: 'sort alphabet ascending',
    text: 'Sort alphabet ascending',
    icon: 'sort alphabet ascending',
  },
  {
    key: 'sort alphabet descending',
    value: 'sort alphabet descending',
    text: 'Sort alphabet descending',
    icon: 'sort alphabet descending',
  },
  {
    key: 'sort ascending',
    value: 'sort ascending',
    text: 'Sort ascending',
    icon: 'sort ascending',
  },
  {
    key: 'sort content ascending',
    value: 'sort content ascending',
    text: 'Sort content ascending',
    icon: 'sort content ascending',
  },
  {
    key: 'sort content descending',
    value: 'sort content descending',
    text: 'Sort content descending',
    icon: 'sort content descending',
  },
  {
    key: 'sort descending',
    value: 'sort descending',
    text: 'Sort descending',
    icon: 'sort descending',
  },
  {
    key: 'sort numeric ascending',
    value: 'sort numeric ascending',
    text: 'Sort numeric ascending',
    icon: 'sort numeric ascending',
  },
  {
    key: 'sort numeric descending',
    value: 'sort numeric descending',
    text: 'Sort numeric descending',
    icon: 'sort numeric descending',
  },
  {
    key: 'sound',
    value: 'sound',
    text: 'Sound',
    icon: 'sound',
  },
  {
    key: 'spy',
    value: 'spy',
    text: 'Spy',
    icon: 'spy',
  },
  {
    key: 'stripe card',
    value: 'stripe card',
    text: 'Stripe card',
    icon: 'stripe card',
  },
  {
    key: 'student',
    value: 'student',
    text: 'Student',
    icon: 'student',
  },
  {
    key: 'talk',
    value: 'talk',
    text: 'Talk',
    icon: 'talk',
  },
  {
    key: 'target',
    value: 'target',
    text: 'Target',
    icon: 'target',
  },
  {
    key: 'teletype',
    value: 'teletype',
    text: 'Teletype',
    icon: 'teletype',
  },
  {
    key: 'television',
    value: 'television',
    text: 'Television',
    icon: 'television',
  },
  {
    key: 'text cursor',
    value: 'text cursor',
    text: 'Text cursor',
    icon: 'text cursor',
  },
  {
    key: 'text telephone',
    value: 'text telephone',
    text: 'Text telephone',
    icon: 'text telephone',
  },
  {
    key: 'theme',
    value: 'theme',
    text: 'Theme',
    icon: 'theme',
  },
  {
    key: 'thumb tack',
    value: 'thumb tack',
    text: 'Thumb tack',
    icon: 'thumb tack',
  },
  {
    key: 'time',
    value: 'time',
    text: 'Time',
    icon: 'time',
  },
  {
    key: 'tm',
    value: 'tm',
    text: 'Tm',
    icon: 'tm',
  },
  {
    key: 'toggle down',
    value: 'toggle down',
    text: 'Toggle down',
    icon: 'toggle down',
  },
  {
    key: 'toggle left',
    value: 'toggle left',
    text: 'Toggle left',
    icon: 'toggle left',
  },
  {
    key: 'toggle right',
    value: 'toggle right',
    text: 'Toggle right',
    icon: 'toggle right',
  },
  {
    key: 'toggle up',
    value: 'toggle up',
    text: 'Toggle up',
    icon: 'toggle up',
  },
  {
    key: 'translate',
    value: 'translate',
    text: 'Translate',
    icon: 'translate',
  },
  {
    key: 'travel',
    value: 'travel',
    text: 'Travel',
    icon: 'travel',
  },
  {
    key: 'treatment',
    value: 'treatment',
    text: 'Treatment',
    icon: 'treatment',
  },
  {
    key: 'triangle down',
    value: 'triangle down',
    text: 'Triangle down',
    icon: 'triangle down',
  },
  {
    key: 'triangle left',
    value: 'triangle left',
    text: 'Triangle left',
    icon: 'triangle left',
  },
  {
    key: 'triangle right',
    value: 'triangle right',
    text: 'Triangle right',
    icon: 'triangle right',
  },
  {
    key: 'triangle up',
    value: 'triangle up',
    text: 'Triangle up',
    icon: 'triangle up',
  },
  {
    key: 'try',
    value: 'try',
    text: 'Try',
    icon: 'try',
  },
  {
    key: 'unhide',
    value: 'unhide',
    text: 'Unhide',
    icon: 'unhide',
  },
  {
    key: 'unlinkify',
    value: 'unlinkify',
    text: 'Unlinkify',
    icon: 'unlinkify',
  },
  {
    key: 'unmute',
    value: 'unmute',
    text: 'Unmute',
    icon: 'unmute',
  },
  {
    key: 'usd',
    value: 'usd',
    text: 'Usd',
    icon: 'usd',
  },
  {
    key: 'user cancel',
    value: 'user cancel',
    text: 'User cancel',
    icon: 'user cancel',
  },
  {
    key: 'user close',
    value: 'user close',
    text: 'User close',
    icon: 'user close',
  },
  {
    key: 'user delete',
    value: 'user delete',
    text: 'User delete',
    icon: 'user delete',
  },
  {
    key: 'user x',
    value: 'user x',
    text: 'User x',
    icon: 'user x',
  },
  {
    key: 'vcard',
    value: 'vcard',
    text: 'Vcard',
    icon: 'vcard',
  },
  {
    key: 'video camera',
    value: 'video camera',
    text: 'Video camera',
    icon: 'video camera',
  },
  {
    key: 'video play',
    value: 'video play',
    text: 'Video play',
    icon: 'video play',
  },
  {
    key: 'volume control phone',
    value: 'volume control phone',
    text: 'Volume control phone',
    icon: 'volume control phone',
  },
  {
    key: 'wait',
    value: 'wait',
    text: 'Wait',
    icon: 'wait',
  },
  {
    key: 'warning circle',
    value: 'warning circle',
    text: 'Warning circle',
    icon: 'warning circle',
  },
  {
    key: 'warning sign',
    value: 'warning sign',
    text: 'Warning sign',
    icon: 'warning sign',
  },
  {
    key: 'warning',
    value: 'warning',
    text: 'Warning',
    icon: 'warning',
  },
  {
    key: 'wi-fi',
    value: 'wi-fi',
    text: 'Wi-fi',
    icon: 'wi-fi',
  },
  {
    key: 'winner',
    value: 'winner',
    text: 'Winner',
    icon: 'winner',
  },
  {
    key: 'wizard',
    value: 'wizard',
    text: 'Wizard',
    icon: 'wizard',
  },
  {
    key: 'woman',
    value: 'woman',
    text: 'Woman',
    icon: 'woman',
  },
  {
    key: 'won',
    value: 'won',
    text: 'Won',
    icon: 'won',
  },
  {
    key: 'wordpress beginner',
    value: 'wordpress beginner',
    text: 'Wordpress beginner',
    icon: 'wordpress beginner',
  },
  {
    key: 'wordpress forms',
    value: 'wordpress forms',
    text: 'Wordpress forms',
    icon: 'wordpress forms',
  },
  {
    key: 'world',
    value: 'world',
    text: 'World',
    icon: 'world',
  },
  {
    key: 'write square',
    value: 'write square',
    text: 'Write square',
    icon: 'write square',
  },
  {
    key: 'x',
    value: 'x',
    text: 'X',
    icon: 'x',
  },
  {
    key: 'yen',
    value: 'yen',
    text: 'Yen',
    icon: 'yen',
  },
  {
    key: 'zip',
    value: 'zip',
    text: 'Zip',
    icon: 'zip',
  },
  {
    key: 'zoom in',
    value: 'zoom in',
    text: 'Zoom in',
    icon: 'zoom in',
  },
  {
    key: 'zoom out',
    value: 'zoom out',
    text: 'Zoom out',
    icon: 'zoom out',
  },
  {
    key: 'zoom',
    value: 'zoom',
    text: 'Zoom',
    icon: 'zoom',
  },
  {
    key: 'bitbucket square',
    value: 'bitbucket square',
    text: 'Bitbucket square',
    icon: 'bitbucket square',
  },
  {
    key: 'checkmark box',
    value: 'checkmark box',
    text: 'Checkmark box',
    icon: 'checkmark box',
  },
  {
    key: 'circle thin',
    value: 'circle thin',
    text: 'Circle thin',
    icon: 'circle thin',
  },
  {
    key: 'compose',
    value: 'compose',
    text: 'Compose',
    icon: 'compose',
  },
  {
    key: 'conversation',
    value: 'conversation',
    text: 'Conversation',
    icon: 'conversation',
  },
  {
    key: 'credit card alternative',
    value: 'credit card alternative',
    text: 'Credit card alternative',
    icon: 'credit card alternative',
  },
  {
    key: 'currency',
    value: 'currency',
    text: 'Currency',
    icon: 'currency',
  },
  {
    key: 'dashboard',
    value: 'dashboard',
    text: 'Dashboard',
    icon: 'dashboard',
  },
  {
    key: 'diamond',
    value: 'diamond',
    text: 'Diamond',
    icon: 'diamond',
  },
  {
    key: 'disk',
    value: 'disk',
    text: 'Disk',
    icon: 'disk',
  },
  {
    key: 'external share',
    value: 'external share',
    text: 'External share',
    icon: 'external share',
  },
  {
    key: 'external square',
    value: 'external square',
    text: 'External square',
    icon: 'external square',
  },
  {
    key: 'external',
    value: 'external',
    text: 'External',
    icon: 'external',
  },
  {
    key: 'facebook official',
    value: 'facebook official',
    text: 'Facebook official',
    icon: 'facebook official',
  },
  {
    key: 'food',
    value: 'food',
    text: 'Food',
    icon: 'food',
  },
  {
    key: 'hourglass zero',
    value: 'hourglass zero',
    text: 'Hourglass zero',
    icon: 'hourglass zero',
  },
  {
    key: 'level down',
    value: 'level down',
    text: 'Level down',
    icon: 'level down',
  },
  {
    key: 'level up',
    value: 'level up',
    text: 'Level up',
    icon: 'level up',
  },
  {
    key: 'log out',
    value: 'log out',
    text: 'Log out',
    icon: 'log out',
  },
  {
    key: 'meanpath',
    value: 'meanpath',
    text: 'Meanpath',
    icon: 'meanpath',
  },
  {
    key: 'money',
    value: 'money',
    text: 'Money',
    icon: 'money',
  },
  {
    key: 'move',
    value: 'move',
    text: 'Move',
    icon: 'move',
  },
  {
    key: 'pencil',
    value: 'pencil',
    text: 'Pencil',
    icon: 'pencil',
  },
  {
    key: 'protect',
    value: 'protect',
    text: 'Protect',
    icon: 'protect',
  },
  {
    key: 'radio',
    value: 'radio',
    text: 'Radio',
    icon: 'radio',
  },
  {
    key: 'remove bookmark',
    value: 'remove bookmark',
    text: 'Remove bookmark',
    icon: 'remove bookmark',
  },
  {
    key: 'resize horizontal',
    value: 'resize horizontal',
    text: 'Resize horizontal',
    icon: 'resize horizontal',
  },
  {
    key: 'resize vertical',
    value: 'resize vertical',
    text: 'Resize vertical',
    icon: 'resize vertical',
  },
  {
    key: 'sign in',
    value: 'sign in',
    text: 'Sign in',
    icon: 'sign in',
  },
  {
    key: 'sign out',
    value: 'sign out',
    text: 'Sign out',
    icon: 'sign out',
  },
  {
    key: 'spoon',
    value: 'spoon',
    text: 'Spoon',
    icon: 'spoon',
  },
  {
    key: 'star half empty',
    value: 'star half empty',
    text: 'Star half empty',
    icon: 'star half empty',
  },
  {
    key: 'star half full',
    value: 'star half full',
    text: 'Star half full',
    icon: 'star half full',
  },
  {
    key: 'ticket',
    value: 'ticket',
    text: 'Ticket',
    icon: 'ticket',
  },
  {
    key: 'times rectangle',
    value: 'times rectangle',
    text: 'Times rectangle',
    icon: 'times rectangle',
  },
  {
    key: 'write',
    value: 'write',
    text: 'Write',
    icon: 'write',
  },
  {
    key: 'youtube play',
    value: 'youtube play',
    text: 'Youtube play',
    icon: 'youtube play',
  },
  {
    key: 'left dropdown',
    value: 'left dropdown',
    text: 'Left dropdown',
    icon: 'left dropdown',
  },
];
